export const products = [


    // My Hero Academy
    {
        id: 1,
        name: "Izuku Midoriya (World Heroes Mission)",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya (World Heroes Mission)/izuku-midoriya-world-heroes-mission_my-hero-academia_silo_sm.png'),
        price: 500000,
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo phiên bản mới nhất của họ là Izuku Midoriya (World Heroes 'Mission)! Bức tượng anh hùng Deku này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Izuku Midoriya (World Heroes 'Mission) trong anime tương ứng. ",
            imageDescription: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya (World Heroes Mission)/izuku-midoriya-world-heroes-mission_my-hero-academia_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS",
            size: "23.9 cm",
            tagName: ["Anime", "Siêu Anh Hùng"],
            otherImages:
                [
                    {
                        id: 100,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya (World Heroes Mission)/izuku-midoriya-world-heroes-mission_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 101,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya (World Heroes Mission)/izuku-midoriya-world-heroes-mission_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 102,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya (World Heroes Mission)/izuku-midoriya-world-heroes-mission_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 103,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya (World Heroes Mission)/izuku-midoriya-world-heroes-mission_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 2,
        name: "Shoto Todoroki (World Heroes Mission)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (World Heroes Mission)/shoto-todoroki-world-heroes-mission_my-hero-academia_silo_sm.png'),
        price: 500000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ Shoto Todoroki (World Heroes ’Mission)! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Shoto Todoroki (Sứ mệnh anh hùng thế giới) trong anime tương ứng của họ.",
            imageDescription: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (World Heroes Mission)/shoto-todoroki-world-heroes-mission_my-hero-academia_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "24.9 cm",
            otherImages:
                [
                    {
                        id: 104,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (World Heroes Mission)/shoto-todoroki-world-heroes-mission_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 105,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (World Heroes Mission)/shoto-todoroki-world-heroes-mission_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 106,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (World Heroes Mission)/shoto-todoroki-world-heroes-mission_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 107,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (World Heroes Mission)/shoto-todoroki-world-heroes-mission_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 3,
        name: "Katsuki Bakugo (World Heroes Mission)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (World Heroes Mission)/katsuki-bakugo-world-heroes-mission_my-hero-academia_silo_sm.png'),
        price: 500000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ Katsuki Bakugo (World Heroes ’Mission)! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Katsuki Bakugo (Sứ mệnh anh hùng thế giới) trong anime tương ứng của họ.",
            imageDescription: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (World Heroes Mission)/katsuki-bakugo-world-heroes-mission_my-hero-academia_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "24.9 cm",
            otherImages:
                [
                    {
                        id: 108,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (World Heroes Mission)/katsuki-bakugo-world-heroes-mission_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 109,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (World Heroes Mission)/katsuki-bakugo-world-heroes-mission_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 110,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (World Heroes Mission)/katsuki-bakugo-world-heroes-mission_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 111,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (World Heroes Mission)/katsuki-bakugo-world-heroes-mission_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 4,
        name: "Ochaco Uraraka",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "new",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka/ochaco-uraraka__silo_sm.png'),
        price: 700000,
        categoryID: 6,
        stock: 5,
        details:
        {
            description: "Plus Ultra! Anh hùng đầy tham vọng Uravity, hay còn được gọi là Ochaco Uraraka, từ My Hero Academia đã gia nhập dòng Taito Spiritale với tỷ lệ 1: 7! "
                + "Mặc trang phục anh hùng của cô ấy và sử dụng kỹ thuật Zero Gravity của cô ấy trên chính cơ sở của nhân vật, nữ anh hùng nổi bọt bay lên không trung với điện thoại và ba lô xoay quanh cô ấy. Cô ấy là một bổ sung tuyệt vời cho bất kỳ bộ sưu tập của người hâm mộ My Hero Academia!",
            imageDescription: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka/ochaco-uraraka__feature.jpg'),
            company: "Taito",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "28 cm",
            otherImages:
                [
                    {
                        id: 112,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka/ochaco-uraraka__gallery_1.jpg'),
                    },
                    {
                        id: 113,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka/ochaco-uraraka__gallery_2.jpg'),
                    },
                    {
                        id: 114,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka/ochaco-uraraka__gallery_3.jpg'),
                    },
                    {
                        id: 115,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka/ochaco-uraraka__gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 5,
        name: "Mina Ashido Hero Suit Version",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Mina Ashido Hero Suit Version/mina-ashido-hero-suit-version_my-hero-academia_silo_sm.png'),
        price: 600000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Lần đầu tiên Mina Ashido, anh hùng Pinky từ My Hero Academia, xuất hiện như một nhân vật trong bộ đồ anh hùng của cô ấy! "
                + "Phong cách Acid, đã được đưa vào nhân vật thông qua các bộ phận hiệu ứng và chân đế có chữ “Melt” bằng phông chữ theo phong cách truyện tranh Mỹ. Axit trên tay cô ấy có thể tháo rời. Bạn cũng có thể chọn “mặt nạ” hoặc “khuôn mặt bình thường” bằng cách thay đổi các bộ phận thay thế. Màu sắc đặc biệt của bộ đồ anh hùng của cô ấy đã được tái tạo với sự chú ý đến từng chi tiết, và nhân vật thể hiện một cách trung thực cảm giác ngây thơ và năng động của cô ấy!",
            imageDescription: require('./productImage/Anime/MyheroAcademia/Mina Ashido Hero Suit Version/mina-ashido-hero-suit-version_my-hero-academia_feature.jpg'),
            company: "Bellfine",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "21 cm",
            otherImages:
                [
                    {
                        id: 116,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Mina Ashido Hero Suit Version/mina-ashido-hero-suit-version_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 117,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Mina Ashido Hero Suit Version/mina-ashido-hero-suit-version_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 118,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Mina Ashido Hero Suit Version/mina-ashido-hero-suit-version_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 119,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Mina Ashido Hero Suit Version/mina-ashido-hero-suit-version_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 6,
        name: "Himiko Toga",
        tagName: ["Anime"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Himiko Toga/himiko-toga_my-hero-academia_silo_sm.png'),
        price: 550000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Các bộ phận được trang bị vũ khí như ống tiêm và dao để lấy máu được nam châm hóa một phần và có thể tháo rời. Những chiếc răng nanh sắc nét đặc trưng và đôi mắt tinh tế được tái hiện một cách hấp dẫn, và các bộ phận hiệu ứng máu được đặt trên bệ và hiệu ứng âm thanh ba chiều càng làm tăng thêm vẻ quyến rũ của cô. "
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Himiko Toga/himiko-toga_my-hero-academia_feature.jpg'),
            company: "Bellfine",
            material: "Nhựa  PVC",
            tagName: ["Anime"],
            size: "21 cm",
            otherImages:
                [
                    {
                        id: 120,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Himiko Toga/himiko-toga_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 121,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Himiko Toga/himiko-toga_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 122,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Himiko Toga/himiko-toga_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 123,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Himiko Toga/himiko-toga_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 7,
        name: "Hawks",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "new",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Hawks/hawks_my-hero-academia_silo_sm.png'),
        price: 720000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Dáng đứng của Hawks được miêu tả vào lúc anh ta đang đối đầu với một nhân vật phản diện. Tư thế hành động của bức tượng cho thấy người anh hùng đã sẵn sàng sử dụng đôi cánh của mình như một thanh kiếm. Hãy chắc chắn cũng để ý đến việc điêu khắc chi tiết và năng động trên hai cánh của anh ấy. "
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Hawks/hawks_my-hero-academia_feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa  PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "42.5 cm",
            otherImages:
                [
                    {
                        id: 124,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Hawks/hawks_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 125,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Hawks/hawks_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 126,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Hawks/hawks_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 127,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Hawks/hawks_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 8,
        name: "Katsuki Bakugo",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "new",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo/katsuki-bakugo_my-hero-academia_silo_sm.png'),
        price: 700000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Katsuki Bakugo mô hình tỷ lệ  1: 8 từ My Hero Academia. Tư thế Động tái tạo chân thực tư thế điên cuồng của Katsuki, đặc trưng là vụ nổ của anh ta khi hành động. "
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo/katsuki-bakugo_my-hero-academia_feature.jpg'),
            company: "Takara Tomy",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "21 cm",
            otherImages:
                [
                    {
                        id: 128,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo/katsuki-bakugo_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 129,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo/katsuki-bakugo_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 130,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo/katsuki-bakugo_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 131,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo/katsuki-bakugo_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 9,
        name: "All Might (Casual Wear)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/All Might (Casual Wear)/all-might-casual-wear_my-hero-academia_silo_sm.png'),
        price: 250000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Cũng giống như nhân vật hành động của Midoriya thời trẻ trong anime, All Might của chúng ta trong trang phục Casual Wear của anh ấy và cũng có cánh tay có khớp nối có thể điều chỉnh được. Các chi tiết đổ bóng trong toàn bộ hình cũng rất chính xác với nguồn gốc, làm tăng thêm độ rõ nét cho hình. Nó đứng trên một đế tròn được từ hóa mạnh với biểu tượng My Hero Academia "
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/All Might (Casual Wear)/all-might-casual-wear_my-hero-academia_feature.jpg'),
            company: "First 4 Figures",
            material: "Nhựa  PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "27.9 cm",
            otherImages:
                [
                    {
                        id: 132,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Casual Wear)/all-might-casual-wear_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 133,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Casual Wear)/all-might-casual-wear_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 134,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Casual Wear)/all-might-casual-wear_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 135,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Casual Wear)/all-might-casual-wear_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 10,
        name: "All Might (Silver Age)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/All Might (Silver Age)/all-might-silver-age_my-hero-academia_silo_sm.png'),
        price: 250000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Cũng giống như nhân vật hành động của Midoriya thời trẻ trong anime, All Might của chúng ta trong trang phục Silver Age của anh ấy và cũng có cánh tay có khớp nối có thể điều chỉnh được. Các chi tiết đổ bóng trong toàn bộ hình cũng rất chính xác với nguồn gốc, làm tăng thêm độ rõ nét cho hình. Nó đứng trên một đế tròn được từ hóa mạnh với biểu tượng My Hero Academia "
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/All Might (Silver Age)/all-might-silver-age_my-hero-academia_feature.jpg'),
            company: "First 4 Figures",
            material: "Nhựa  PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "27.9 cm",
            otherImages:
                [
                    {
                        id: 136,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Silver Age)/all-might-silver-age_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 137,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Silver Age)/all-might-silver-age_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 138,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Silver Age)/all-might-silver-age_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 139,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Silver Age)/all-might-silver-age_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 11,
        name: "All Might (Golden Age)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/All Might (Golden Age)/all-might-golden-age_my-hero-academia_silo_sm.png'),
        price: 250000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Cũng giống như nhân vật hành động của Midoriya thời trẻ trong anime, All Might của chúng ta trong trang phục Golden Age của anh ấy và cũng có cánh tay có khớp nối có thể điều chỉnh được. Các chi tiết đổ bóng trong toàn bộ hình cũng rất chính xác với nguồn gốc, làm tăng thêm độ rõ nét cho hình. Nó đứng trên một đế tròn được từ hóa mạnh với biểu tượng My Hero Academia "
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/All Might (Golden Age)/all-might-golden-age_my-hero-academia_feature.jpg'),
            company: "First 4 Figures",
            material: "Nhựa  PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "27.9 cm",
            otherImages:
                [
                    {
                        id: 140,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Golden Age)/all-might-golden-age_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 141,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Golden Age)/all-might-golden-age_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 142,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Golden Age)/all-might-golden-age_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 143,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/All Might (Golden Age)/all-might-golden-age_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 12,
        name: "Izuku Midoriya",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya/izuku-midoriya_my-hero-academia_silo_sm.png'),
        price: 450000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Từ loạt phim hoạt hình nổi tiếng My Hero Academia , nhân vật chính Izuku Midoriya, còn được gọi là Deku, đã được tạo ra với tỷ lệ 1: 4! Hình có tỷ lệ 1: 4 và chiều cao xấp xỉ 34,8cm. Hãy nhớ thêm anh ấy vào bộ sưu tập của bạn! "
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya/izuku-midoriya_my-hero-academia_feature.jpg'),
            company: "Takara Tomy",
            material: "Nhựa  PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "34.8 cm",
            otherImages:
                [
                    {
                        id: 144,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya/izuku-midoriya_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 145,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya/izuku-midoriya_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 146,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya/izuku-midoriya_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 147,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya/izuku-midoriya_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 13,
        name: "Izuku Midoriya 2",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya v2/izuku-midoriya_my-hero-academia_silo_sm.png'),
        price: 650000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Từ loạt phim hoạt hình nổi tiếng My Hero Academia , nhân vật chính Izuku Midoriya, còn được gọi là Deku. Các mặt của căn cứ chịu ảnh hưởng của U.A. Khuôn viên trường trung học. Bản thân thiết kế là các chi tiết bằng đá cẩm thạch mà bạn nhìn thấy phía trên ba cánh cửa của lối vào khuôn viên trường, và ở giữa là logo của trường."
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya v2/izuku-midoriya_my-hero-academia_feature.jpg'),
            company: "First 4 Figuresy",
            material: "Resin",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "40.1 cm",
            otherImages:
                [
                    {
                        id: 148,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya v2/izuku-midoriya_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 149,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya v2/izuku-midoriya_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 150,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya v2/izuku-midoriya_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 151,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya v2/izuku-midoriya_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 14,
        name: "Himiko Toga 2",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Himiko Toga v2/himiko-toga_my-hero-academia_silo_sm version2.png'),
        price: 350000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Mô hình Himiko Toga từ loạt phim My Hero Academia! Chiều cao khoảng 20.3cm và có hình Himiko Toga trong trang bị chiến đấu của cô ấy từ bộ phim hoạt hình nổi tiếng My Hero Academia."
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Himiko Toga v2/himiko-toga_my-hero-academia_feature.jpg'),
            company: "Banpresto",
            material: "Nhựa, ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "20.3 cm",
            otherImages:
                [
                    {
                        id: 152,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Himiko Toga v2/himiko-toga_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 153,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Himiko Toga v2/himiko-toga_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 154,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Himiko Toga v2/himiko-toga_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 155,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Himiko Toga v2/himiko-toga_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 15,
        name: "Izuku Midoriya vs Stain",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya vs Stain/izuku-midoriya-vs-stain_my-hero-academia_silo_sm.png'),
        price: 3550000,
        depositPrice: 300000,
        categoryID: 6,
        stock: 0,
        details:
        {
            description: "Chiều cao 30cm, bao gồm phần đế và hiệu ứng chi tiết, và có nhân vật chính của bộ anime nổi tiếng My Hero Academia Izuku Midoriya, còn được gọi là Deku, chiến đấu với kẻ phản diện Stain."
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya vs Stain/izuku-midoriya-vs-stain_my-hero-academia_feature.jpg'),
            company: "Takara Tomy",
            material: "Nhựa, ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "30 cm",
            otherImages:
                [
                    {
                        id: 156,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya vs Stain/izuku-midoriya-vs-stain_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 157,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya vs Stain/izuku-midoriya-vs-stain_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 158,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya vs Stain/izuku-midoriya-vs-stain_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 159,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Izuku Midoriya vs Stain/izuku-midoriya-vs-stain_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 16,
        name: "Katsuki Bakugo (Version 2)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "available",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (Version 2)/katsuki-bakugo-version-2_my-hero-academia_silo_sm.png'),
        price: 650000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Tư thế chụp Bakugo trong trang phục anh hùng mới nhất của anh ấy vào khoảnh khắc anh ấy bay lên không trung bằng cách sử dụng Explosion Quirk của mình. Các chi tiết của trang phục được tái tạo một cách trung thực và ngay cả các bộ phận như hiệu ứng và chân đế cũng được điêu khắc tỉ mỉ, mang lại cảm giác chân thực cho toàn bộ trang phục."
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (Version 2)/katsuki-bakugo-version-2_my-hero-academia_feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa, ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "25.7 cm",
            otherImages:
                [
                    {
                        id: 160,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (Version 2)/katsuki-bakugo-version-2_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 161,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (Version 2)/katsuki-bakugo-version-2_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 162,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (Version 2)/katsuki-bakugo-version-2_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 163,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Katsuki Bakugo (Version 2)/katsuki-bakugo-version-2_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 17,
        name: "Midoriya, Bakugo & Todoroki (Deluxe Version)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Midoriya, Bakugo & Todoroki (Deluxe Version)/midoriya-bakugo-todoroki-deluxe-version_my-hero-academia_silo_sm.png'),
        price: 5550000,
        depositPrice: 500000,
        categoryID: 6,
        stock: 0,
        details:
        {
            description: "Phiên bản Deluxe cho phép bạn thay đổi mức cường độ của Deku, Dynamight và Shoto. Với những cái đầu có thể hoán đổi bổ sung, Deku thể hiện sự tập trung cao độ của mình, Dynamight nghiến răng để dự đoán một cuộc chiến khốc liệt và Shoto thể hiện sự bình tĩnh và chiến thuật đặc trưng của mình. Ba nhà vô địch này xuất phát từ một căn cứ theo chủ đề UA được neo đậu bởi một tượng đài để vinh danh Anh hùng vĩ đại nhất trong số họ: All Might!"
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Midoriya, Bakugo & Todoroki (Deluxe Version)/midoriya-bakugo-todoroki-deluxe-version_my-hero-academia_gallery_featurejpg.jpg'),
            company: "Prime 1 Studio",
            material: "Polystone",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "68.6 cm",
            otherImages:
                [
                    {
                        id: 164,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Midoriya, Bakugo & Todoroki (Deluxe Version)/midoriya-bakugo-todoroki-deluxe-version_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 165,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Midoriya, Bakugo & Todoroki (Deluxe Version)/midoriya-bakugo-todoroki-deluxe-version_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 166,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Midoriya, Bakugo & Todoroki (Deluxe Version)/midoriya-bakugo-todoroki-deluxe-version_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 167,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Midoriya, Bakugo & Todoroki (Deluxe Version)/midoriya-bakugo-todoroki-deluxe-version_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 18,
        name: "Ochaco Uraraka (Version 2)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "new",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka (Version 2)/ochaco-uraraka-ver2__silo_sm.png'),
        price: 350000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Tư thế chụp Ochaco khi cô ấy bay lơ lửng một cách dễ dàng bằng cách sử dụng Trò chơi Không trọng lực của mình. " +
                "Người ta chú ý nhiều hơn đến những nếp nhăn mỏng manh trên trang phục do chuyển động của cô ấy, cũng như cách mà đống đổ nát có vẻ lơ lửng trong không trọng lực." +
                " Hãy chắc chắn rằng bạn sẽ thích figure này bằng cách thêm em ấy vào bộ sưu tập của mình!"
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka (Version 2)/ochaco-uraraka-ver2__feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "26.8 cm",
            otherImages:
                [
                    {
                        id: 168,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka (Version 2)/ochaco-uraraka-ver2__gallery_1.jpg'),
                    },
                    {
                        id: 169,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka (Version 2)/ochaco-uraraka-ver2__gallery_2.jpg'),
                    },
                    {
                        id: 170,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka (Version 2)/ochaco-uraraka-ver2__gallery_3.jpg'),
                    },
                    {
                        id: 171,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Ochaco Uraraka (Version 2)/ochaco-uraraka-ver2__gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 19,
        name: "Shoto Todoroki (Version 2)",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "new",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (Version 2)/shoto-todoroki-version-2_my-hero-academia_silo_sm.png'),
        price: 350000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Khoác lên mình bộ trang phục anh hùng mới nhất của mình, Todoroki thoải mái điều khiển Câu nói nửa lạnh nửa nóng của mình giữa trận chiến. Để khen ngợi tư thế ấn tượng của võ sĩ tầm xa này, tác phẩm điêu khắc thực tế của tảng băng mạnh mẽ từ mặt đất, kết hợp với ngọn lửa rực lửa của anh ta để tạo ra một kết thúc ấn tượng cho tác phẩm này."
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (Version 2)/shoto-todoroki-version-2_my-hero-academia_feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "26.2 cm",
            otherImages:
                [
                    {
                        id: 172,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (Version 2)/shoto-todoroki-version-2_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 173,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (Version 2)/shoto-todoroki-version-2_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 174,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (Version 2)/shoto-todoroki-version-2_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 175,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Shoto Todoroki (Version 2)/shoto-todoroki-version-2_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 20,
        name: "Tsuyu Asui Uniform Version",
        tagName: ["Anime", "Siêu Anh Hùng"],
        status: "new",
        thumbImg: require('./productImage/Anime/MyheroAcademia/Tsuyu Asui Uniform Version/tsuyu-asui-uniform-version_my-hero-academia_silo_sm.png'),
        price: 300000,
        categoryID: 6,
        stock: 10,
        details:
        {
            description: "Từ series KONEKORE, Tsuyu Asui, bạn cùng lớp cho đến nhân vật chính Izuku Midoriya của My Hero Academia, đều ở đây! " +
                "Chuyến đi vui vẻ đến trường của Tsuyu trong bộ đồng phục của cô ấy đã được miêu tả. Xin lưu ý tư thế của Tsuyu khi cô ấy chạy đến trường với mái tóc bồng bềnh phía sau. Bạn có thể kết nối từng nhân vật trong My Hero Academia bằng giá đỡ chung và thưởng thức cảnh họ yêu thích đến trường！"
            ,
            imageDescription: require('./productImage/Anime/MyheroAcademia/Tsuyu Asui Uniform Version/tsuyu-asui-uniform-version_my-hero-academia_feature.jpg'),
            company: "Bellfine",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Siêu Anh Hùng"],
            size: "19.8 cm",
            otherImages:
                [
                    {
                        id: 176,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Tsuyu Asui Uniform Version/tsuyu-asui-uniform-version_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 177,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Tsuyu Asui Uniform Version/tsuyu-asui-uniform-version_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 178,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Tsuyu Asui Uniform Version/tsuyu-asui-uniform-version_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 179,
                        imgUrl: require('./productImage/Anime/MyheroAcademia/Tsuyu Asui Uniform Version/tsuyu-asui-uniform-version_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },

    // Dragon Ball
    {
        id: 21,
        name: "Cell First Form",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/DragonBall/Cell First Form/cell-first-form_dragon-ball_silo_sm.png'),
        price: 450000,
        depositPrice: 150000,
        categoryID: 2,
        stock: 0,
        details:
        {
            description: "Từ Dragon Ball Z, Cell First Form tham gia S.H.Figuarts! Các tùy chọn để hiển thị nhân vật anime này bao gồm đầu, tay và đuôi được thiết kế để tái tạo ngoại hình của anh ta khi hấp thụ kẻ thù!"
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Cell First Form/cell-first-form_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "17 cm",
            otherImages:
                [
                    {
                        id: 180,
                        imgUrl: require('./productImage/Anime/DragonBall/Cell First Form/cell-first-form_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 181,
                        imgUrl: require('./productImage/Anime/DragonBall/Cell First Form/cell-first-form_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 182,
                        imgUrl: require('./productImage/Anime/DragonBall/Cell First Form/cell-first-form_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 183,
                        imgUrl: require('./productImage/Anime/DragonBall/Cell First Form/cell-first-form_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 22,
        name: "Cell Perfect (Vs Omnibus Super)",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/DragonBall/Cell Perfect (Vs Omnibus Super)/cell-perfect-vs-omnibus-super_dragon-ball_silo_sm.png'),
        price: 350000,
        depositPrice: 100000,
        categoryID: 2,
        stock: 0,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ Cell Perfect (Vs Omnibus Super)! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Cell Perfect (Vs Omnibus Super) trong anime tương ứng. " +
                "Cao xấp xỉ 26.9 cm, Cell Perfect (Vs Omnibus Super) được nhìn thấy trong tư thế phổ biến của hắn."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Cell Perfect (Vs Omnibus Super)/cell-perfect-vs-omnibus-super_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "26.9 cm",
            otherImages:
                [
                    {
                        id: 184,
                        imgUrl: require('./productImage/Anime/DragonBall/Cell Perfect (Vs Omnibus Super)/cell-perfect-vs-omnibus-super_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 185,
                        imgUrl: require('./productImage/Anime/DragonBall/Cell Perfect (Vs Omnibus Super)/cell-perfect-vs-omnibus-super_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 186,
                        imgUrl: require('./productImage/Anime/DragonBall/Cell Perfect (Vs Omnibus Super)/cell-perfect-vs-omnibus-super_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 187,
                        imgUrl: require('./productImage/Anime/DragonBall/Cell Perfect (Vs Omnibus Super)/cell-perfect-vs-omnibus-super_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 23,
        name: "Golden Frieza (Back To The Film)",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/DragonBall/Golden Frieza (Back To The Film)/golden-frieza-back-to-the-film_dragon-ball_silo_sm.png'),
        price: 350000,
        depositPrice: 100000,
        categoryID: 2,
        stock: 0,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Golden Frieza (Back To The Film)! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Golden Frieza (Back To The Film) trong anime tương ứng của họ. Cao khoảng 7,87 inch, Golden Frieza (Back To The Film) được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Golden Frieza (Back To The Film)/golden-frieza-back-to-the-film_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "20.1 cm",
            otherImages:
                [
                    {
                        id: 188,
                        imgUrl: require('./productImage/Anime/DragonBall/Golden Frieza (Back To The Film)/golden-frieza-back-to-the-film_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 189,
                        imgUrl: require('./productImage/Anime/DragonBall/Golden Frieza (Back To The Film)/golden-frieza-back-to-the-film_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 190,
                        imgUrl: require('./productImage/Anime/DragonBall/Golden Frieza (Back To The Film)/golden-frieza-back-to-the-film_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 191,
                        imgUrl: require('./productImage/Anime/DragonBall/Golden Frieza (Back To The Film)/golden-frieza-back-to-the-film_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 24,
        name: "Omega Shenron (Vs Omnibus Super)",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/DragonBall/Omega Shenron (Vs Omnibus Super)/omega-shenron-vs-omnibus-super_dragon-ball_silo_sm.png'),
        price: 455000,
        categoryID: 2,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Omega Shenron (Vs Omnibus Super)! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Omega Shenron (Vs Omnibus Super) trong anime tương ứng của họ. Cao khoảng 23.9 cm, Omega Shenron (Vs Omnibus Super) được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Omega Shenron (Vs Omnibus Super)/omega-shenron-vs-omnibus-super_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "23.9  cm",
            otherImages:
                [
                    {
                        id: 192,
                        imgUrl: require('./productImage/Anime/DragonBall/Omega Shenron (Vs Omnibus Super)/omega-shenron-vs-omnibus-super_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 193,
                        imgUrl: require('./productImage/Anime/DragonBall/Omega Shenron (Vs Omnibus Super)/omega-shenron-vs-omnibus-super_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 194,
                        imgUrl: require('./productImage/Anime/DragonBall/Omega Shenron (Vs Omnibus Super)/omega-shenron-vs-omnibus-super_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 195,
                        imgUrl: require('./productImage/Anime/DragonBall/Omega Shenron (Vs Omnibus Super)/omega-shenron-vs-omnibus-super_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 25,
        name: "Piccolo",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/DragonBall/Piccolo/piccolo_dragon-ball_silo_sm.png'),
        price: 455000,
        categoryID: 2,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Piccolo! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Piccolo trong anime tương ứng của họ. Cao khoảng 19 cm, Piccolo được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Piccolo/piccolo_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "19  cm",
            otherImages:
                [
                    {
                        id: 196,
                        imgUrl: require('./productImage/Anime/DragonBall/Piccolo/piccolo_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 197,
                        imgUrl: require('./productImage/Anime/DragonBall/Piccolo/piccolo_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 198,
                        imgUrl: require('./productImage/Anime/DragonBall/Piccolo/piccolo_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 199,
                        imgUrl: require('./productImage/Anime/DragonBall/Piccolo/piccolo_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 26,
        name: "Son Goku (Ex Mystical Adventure)",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/DragonBall/Son Goku (Ex Mystical Adventure)/son-goku-ex-mystical-adventure_dragon-ball_silo_sm.png'),
        price: 255000,
        categoryID: 2,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Son Goku (Ex Mystical Adventure)! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Son Goku (Ex Mystical Adventure) trong anime tương ứng của họ. Cao khoảng 12 cm, Son Goku (Ex Mystical Adventure) được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Son Goku (Ex Mystical Adventure)/son-goku-ex-mystical-adventure_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "11.9  cm",
            otherImages:
                [
                    {
                        id: 200,
                        imgUrl: require('./productImage/Anime/DragonBall/Son Goku (Ex Mystical Adventure)/son-goku-ex-mystical-adventure_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 201,
                        imgUrl: require('./productImage/Anime/DragonBall/Son Goku (Ex Mystical Adventure)/son-goku-ex-mystical-adventure_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 202,
                        imgUrl: require('./productImage/Anime/DragonBall/Son Goku (Ex Mystical Adventure)/son-goku-ex-mystical-adventure_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 203,
                        imgUrl: require('./productImage/Anime/DragonBall/Son Goku (Ex Mystical Adventure)/son-goku-ex-mystical-adventure_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 27,
        name: "Super Saiyan 4 Son Goku",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/DragonBall/Super Saiyan 4 Son Goku/super-saiyan-4-son-goku_dragon-ball_silo_sm.png'),
        price: 354000,
        categoryID: 2,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Super Saiyan 4 Son Goku! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Super Saiyan 4 Son Goku trong anime tương ứng của họ. Cao khoảng 15.5 cm, Super Saiyan 4 Son Goku được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Super Saiyan 4 Son Goku/super-saiyan-4-son-goku_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "15.5  cm",
            otherImages:
                [
                    {
                        id: 204,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan 4 Son Goku/super-saiyan-4-son-goku_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 205,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan 4 Son Goku/super-saiyan-4-son-goku_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 206,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan 4 Son Goku/super-saiyan-4-son-goku_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 207,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan 4 Son Goku/super-saiyan-4-son-goku_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 28,
        name: "Super Saiyan God Super Saiyan Gogeta",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Gogeta/super-saiyan-god-super-saiyan-gogeta_dragon-ball_silo_sm.png'),
        price: 356000,
        categoryID: 2,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Super Saiyan God Super Saiyan Gogeta! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Super Saiyan God Super Saiyan Gogeta trong anime tương ứng của họ. Cao khoảng 14 cm, Super Saiyan God Super Saiyan Gogeta được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Gogeta/super-saiyan-god-super-saiyan-gogeta_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "14  cm",
            otherImages:
                [
                    {
                        id: 208,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Gogeta/super-saiyan-god-super-saiyan-gogeta_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 209,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Gogeta/super-saiyan-god-super-saiyan-gogeta_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 210,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Gogeta/super-saiyan-god-super-saiyan-gogeta_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 211,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Gogeta/super-saiyan-god-super-saiyan-gogeta_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 29,
        name: "Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super)",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super)/super-saiyan-god-super-saiyan-son-goku-vegeta-vs-omnibus-super_dragon-ball_silo_sm.png'),
        price: 455000,
        categoryID: 2,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super)! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super) trong anime tương ứng của họ. Cao khoảng 20 cm, Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super) được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super)/super-saiyan-god-super_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "20  cm",
            otherImages:
                [
                    {
                        id: 212,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super)/super-saiyan-god-gallery_1.jpg'),
                    },
                    {
                        id: 213,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super)/super-saiyan-god-gallery_2.jpg'),
                    },
                    {
                        id: 214,
                        imgUrl: require('./productImage/Anime/DragonBall/Super Saiyan God Super Saiyan Son Goku & Vegeta (Vs Omnibus Super)/super-saiyan-god-gallery_3.jpg'),
                    },
                ],

        }
    },
    {
        id: 30,
        name: "Trunks (Manga Dimensions)",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/DragonBall/Trunks (Manga Dimensions)/trunks-manga-dimensions_dragon-ball_silo_sm.png'),
        price: 455000,
        categoryID: 2,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Trunks (Manga Dimensions)! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Trunks (Manga Dimensions) trong anime tương ứng của họ. Cao khoảng 25.4 cm, Trunks (Manga Dimensions) được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Trunks (Manga Dimensions)/trunks-manga-dimensions_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "25.4  cm",
            otherImages:
                [
                    {
                        id: 215,
                        imgUrl: require('./productImage/Anime/DragonBall/Trunks (Manga Dimensions)/trunks-manga-dimensions_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 216,
                        imgUrl: require('./productImage/Anime/DragonBall/Trunks (Manga Dimensions)/trunks-manga-dimensions_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 217,
                        imgUrl: require('./productImage/Anime/DragonBall/Trunks (Manga Dimensions)/trunks-manga-dimensions_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 218,
                        imgUrl: require('./productImage/Anime/DragonBall/Trunks (Manga Dimensions)/trunks-manga-dimensions_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 31,
        name: "Vegeta",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/DragonBall/Vegeta/vegeta_dragon-ball_silo_sm.png'),
        price: 455000,
        categoryID: 2,
        stock: 10,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất của họ từ Dragon Ball Super: Vegeta! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Vegeta trong anime tương ứng của họ. Cao khoảng 10 cm, Vegeta được nhìn thấy trong tư thế phổ biến của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/DragonBall/Vegeta/vegeta_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "10 cm",
            otherImages:
                [
                    {
                        id: 219,
                        imgUrl: require('./productImage/Anime/DragonBall/Vegeta/vegeta_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 220,
                        imgUrl: require('./productImage/Anime/DragonBall/Vegeta/vegeta_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 221,
                        imgUrl: require('./productImage/Anime/DragonBall/Vegeta/vegeta_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 222,
                        imgUrl: require('./productImage/Anime/DragonBall/Vegeta/vegeta_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },

    // Jujutsu Kaisen
    {
        id: 32,
        name: "Yuta Okkotsu and Special Grade Vengeful Cursed Spirit Rika Orimoto",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu and Special Grade Vengeful Cursed Spirit Rika Orimoto/yuta-okkotsu-and-special-grade-vengeful-cursed-spirit-rika-orimoto_jujutsu-kaisen_silo_sm.png'),
        price: 850000,
        depositPrice: 350000,
        categoryID: 7,
        stock: 0,
        details:
        {
            description: "Dựa trên sự xuất hiện của họ trong anime movie Jujutsu Kaisen 0, một nhân vật quy mô thứ bảy tuyệt đẹp của Yuta Okkotsu và 'Linh hồn bị nguyền rủa hạng đặc biệt' Rika Orimoto! Nhân vật Jujutsu Kaisen năng động này bao gồm một cơ sở bóng tối phù hợp, với Yuta sẵn sàng tấn công và hình dạng linh hồn bị nguyền rủa đầy thù hận của Rika nhe hàm răng đáng sợ của cô ấy"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu and Special Grade Vengeful Cursed Spirit Rika Orimoto/yuta-okkotsu-and-special-grade-vengeful-cursed-spirit-rika-orimoto_jujutsu-kaisen_feature.jpg'),
            company: "FURYU Corporation",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "17 cm",
            otherImages:
                [
                    {
                        id: 223,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu and Special Grade Vengeful Cursed Spirit Rika Orimoto/yuta-okkotsu-and-special-grade-vengeful-cursed-spirit-rika-orimoto_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 224,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu and Special Grade Vengeful Cursed Spirit Rika Orimoto/yuta-okkotsu-and-special-grade-vengeful-cursed-spirit-rika-orimoto_jujutsu-kaisen_gallery_2.jpg'),

                    },
                    {
                        id: 225,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu and Special Grade Vengeful Cursed Spirit Rika Orimoto/yuta-okkotsu-and-special-grade-vengeful-cursed-spirit-rika-orimoto_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 226,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu and Special Grade Vengeful Cursed Spirit Rika Orimoto/yuta-okkotsu-and-special-grade-vengeful-cursed-spirit-rika-orimoto_jujutsu-kaisen_gallery_4.jpg'),

                    },
                ],

        }
    },
    {
        id: 33,
        name: "Yuta Okkotsu (0 Version)",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu (0 Version)/yuta-okkotsu-0-version_jujutsu-kaisen_silo_sm.png'),
        price: 350000,
        depositPrice: 150000,
        categoryID: 7,
        stock: 0,
        details:
        {
            description: "Yuta Okkotsu từ Jujutsu Kaisen 0 trở nên sống động trong một nhân vật tỷ lệ 1: 8, sẵn sàng cho trận chiến và nắm chặt thanh kiếm của mình. Anh ấy cao 6,89 'và được nhìn thấy mặc áo khoác rộng màu trắng và quần đen'"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu (0 Version)/yuta-okkotsu-0-version_jujutsu-kaisen_feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "17.5 cm",
            otherImages:
                [
                    {
                        id: 227,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu (0 Version)/yuta-okkotsu-0-version_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 228,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu (0 Version)/yuta-okkotsu-0-version_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 229,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu (0 Version)/yuta-okkotsu-0-version_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 230,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuta Okkotsu (0 Version)/yuta-okkotsu-0-version_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 34,
        name: "Yuji Itadori",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori v2/yuji-itadori_jujutsu-kaisen_silo_sm.png'),
        price: 350000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Nhân vật anime có tư thế cố định này ghi lại khoảnh khắc anh ta tung ra đòn tấn công tàn khốc của Black Flash, sử dụng các phần mờ để làm nổi bật bộ phim!"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori v2/yuji-itadori_jujutsu-kaisen_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "19 cm",
            otherImages:
                [
                    {
                        id: 231,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori v2/yuji-itadori_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 232,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori v2/yuji-itadori_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 233,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori v2/yuji-itadori_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 234,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori v2/yuji-itadori_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 35,
        name: "Yuji Itadori",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori/yuji-itadori_jujutsu-kaisen_silo_sm.png'),
        price: 350000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: " Yuji Itadori trở nên sống động dựa trên một hình minh họa gốc được vẽ riêng cho nhân vật này. Sức mạnh đặc trưng của anh ấy trong chiến đấu tay đôi thể hiện ở tư thế mạnh mẽ của anh ấy khi anh ấy ở tư thế sẵn sàng. Bằng cách gắn các bộ phận hiệu ứng, người dùng có thể tái tạo thêm bầu không khí của Yuji Itadori giữa trận chiến! Các bộ phận hiệu ứng cũng phát sáng khi được chiếu sáng bằng đèn đen"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori/yuji-itadori_jujutsu-kaisen_feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "18.5 cm",
            otherImages:
                [
                    {
                        id: 235,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori/yuji-itadori_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 236,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori/yuji-itadori_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 237,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori/yuji-itadori_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 238,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Yuji Itadori/yuji-itadori_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 36,
        name: "Sukuna Ryomen",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Sukuna Ryomen/sukuna-ryomen_jujutsu-kaisen_silo_sm.png'),
        price: 750000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Sukuna được nhìn thấy đang ngồi trên ngai vàng đầu lâu và xuất hiện với mái tóc nhọn và những vết hằn trên mặt. Anh ấy cũng đang mặc một bộ kimono sáng màu với viền tối, khăn quàng cổ và giày như trong truyện."
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Sukuna Ryomen/sukuna-ryomen_jujutsu-kaisen_feature.jpg'),
            company: "FURYU Corporation",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "21.5 cm",
            otherImages:
                [
                    {
                        id: 239,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Sukuna Ryomen/sukuna-ryomen_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 240,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Sukuna Ryomen/sukuna-ryomen_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 241,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Sukuna Ryomen/sukuna-ryomen_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 242,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Sukuna Ryomen/sukuna-ryomen_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 37,
        name: "Suguru Geto (0 Version)",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Suguru Geto (0 Version)/suguru-geto-0-version_jujutsu-kaisen_silo_sm.png'),
        price: 750000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Suguru Geto từ Jujutsu Kaisen 0 trở nên sống động trong một hình vẽ tỷ lệ 1: 8 được tạo ra trong tư thế mạnh mẽ nắm lấy Playful Cloud. Anh ấy đứng ở vị trí 8,86 và được nhìn thấy mặc trang phục tu sĩ của mình với áo choàng yukata đen, tất trắng tabi và dép zori"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Suguru Geto (0 Version)/suguru-geto-0-version_jujutsu-kaisen_feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "22.5 cm",
            otherImages:
                [
                    {
                        id: 243,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Suguru Geto (0 Version)/suguru-geto-0-version_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 244,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Suguru Geto (0 Version)/suguru-geto-0-version_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 245,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Suguru Geto (0 Version)/suguru-geto-0-version_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 246,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Suguru Geto (0 Version)/suguru-geto-0-version_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 38,
        name: "Satoru Gojo",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v3/satoru-gojo_jujutsu-kaisen_silo_sm.png'),
        price: 850000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Từ anime Jujutsu Kaisen, Satoru Gojo sẽ được Estream phát hành dưới dạng figure tỷ lệ 1: 7! Với chiều cao gần 10 inch, vẻ ngoài của phù thủy quyền năng đã được tái tạo chính xác với độ chi tiết cực cao. Con số PVC Collectible này là một bổ sung tuyệt vời cho bất kỳ bộ sưu tập Jujutsu Kaisen nào!"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v3/satoru-gojo_jujutsu-kaisen_feature.jpg'),
            company: "Estream",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "25.1 cm",
            otherImages:
                [
                    {
                        id: 247,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v3/satoru-gojo_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 248,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v3/satoru-gojo_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 249,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v3/satoru-gojo_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 250,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v3/satoru-gojo_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 39,
        name: "Satoru Gojo",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v2/satoru-gojo_jujutsu-kaisen_silo_sm.png'),
        price: 850000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Từ anime Jujutsu Kaisen, Satoru Gojo sẽ được Estream phát hành dưới dạng figure tỷ lệ 1: 7! Với chiều cao gần 10 inch, vẻ ngoài của phù thủy quyền năng đã được tái tạo chính xác với độ chi tiết cực cao. Con số PVC Collectible này là một bổ sung tuyệt vời cho bất kỳ bộ sưu tập Jujutsu Kaisen nào!"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v2/satoru-gojo_jujutsu-kaisen_feature.jpg'),
            company: "FURYU Corporation",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "24 cm",
            otherImages:
                [
                    {
                        id: 251,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v2/satoru-gojo_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 252,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v2/satoru-gojo_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 253,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v2/satoru-gojo_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 254,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo v2/satoru-gojo_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 40,
        name: "Satoru Gojo (0 Version)",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo (0 Version)/satoru-gojo-0-version_jujutsu-kaisen_silo_sm.png'),
        price: 780000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Satoru Gojo từ Jujutsu Kaisen 0 trở nên sống động trong một nhân vật tỷ lệ 1: 8 chuẩn bị cho trận chiến với đôi mắt ấn tượng nhìn ra từ bên dưới băng của mình. Thầy giáo Jujutsu cao 8,86 và được nhìn thấy mặc áo khoác đen cổ cao kết hợp với quần âu và đôi bốt tối màu."
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo (0 Version)/satoru-gojo-0-version_jujutsu-kaisen_feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "22.5 cm",
            otherImages:
                [
                    {
                        id: 255,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo (0 Version)/satoru-gojo-0-version_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 256,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo (0 Version)/satoru-gojo-0-version_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 257,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo (0 Version)/satoru-gojo-0-version_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 258,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo (0 Version)/satoru-gojo-0-version_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 41,
        name: "Satoru Gojo",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo/satoru-gojo_dragon-ball_silo_sm.png'),
        price: 550000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Từ anime truyền hình ăn khách Jujutsu Kaisen, Satoru Gojo tham gia FiguartsZERO! Các bộ phận hiệu ứng tái tạo Kỹ thuật rỗng màu tím của anh ta!"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo/satoru-gojo_dragon-ball_feature.jpg'),
            company: "Bandai",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "17 cm",
            otherImages:
                [
                    {
                        id: 259,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo/satoru-gojo_dragon-ball_gallery_1.jpg'),
                    },
                    {
                        id: 260,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo/satoru-gojo_dragon-ball_gallery_2.jpg'),
                    },
                    {
                        id: 261,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo/satoru-gojo_dragon-ball_gallery_3.jpg'),
                    },
                    {
                        id: 262,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Satoru Gojo/satoru-gojo_dragon-ball_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 42,
        name: "Nobara Kugisaki",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Nobara Kugisaki/nobara-kugisaki__silo_sm.png'),
        price: 620000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Dựa trên hình minh họa gốc được vẽ riêng cho bức tượng này, Nobara trở nên sống động khi cô ấy đang chuẩn bị sử dụng “Kỹ thuật búp bê rơm” của mình. Cảm giác năng động trong sự lắc lư của váy và mái tóc của cô ấy làm cho cảm giác như cô ấy sắp di chuyển bất cứ lúc nào"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Nobara Kugisaki/nobara-kugisaki__feature.jpg'),
            company: "Kotobukiya",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "19 cm",
            otherImages:
                [
                    {
                        id: 263,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Nobara Kugisaki/nobara-kugisaki__gallery_1.jpg'),
                    },
                    {
                        id: 264,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Nobara Kugisaki/nobara-kugisaki__gallery_2.jpg'),
                    },
                    {
                        id: 265,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Nobara Kugisaki/nobara-kugisaki__gallery_3.jpg'),
                    },
                    {
                        id: 266,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Nobara Kugisaki/nobara-kugisaki__gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 43,
        name: "Megumi Fushiguro Figma",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/JujutsuKaisen/Megumi Fushiguro Figma/megumi-fushiguro-figma_jujutsu-kaisen_silo_sm.png'),
        price: 420000,
        categoryID: 7,
        stock: 10,
        details:
        {
            description: "Bằng cách sử dụng các khớp mềm mại nhưng có thể điều chỉnh được của figma, bạn có thể tạo ra nhiều tư thế khác nhau từ bộ truyện. Một loại nhựa dẻo được sử dụng cho các khu vực quan trọng, cho phép giữ nguyên tỷ lệ mà không ảnh hưởng đến khả năng định hình. Anh ấy có ba biểu cảm khuôn mặt bao gồm khuôn mặt tiêu chuẩn, khuôn mặt chiến đấu và khuôn mặt Chimera Shadow Garden"
            ,
            imageDescription: require('./productImage/Anime/JujutsuKaisen/Megumi Fushiguro Figma/megumi-fushiguro-figma_jujutsu-kaisen_feature.jpg'),
            company: "Good Smile Company",
            material: "Nhựa ABS, PVC",
            tagName: ["Anime", "Hành động"],
            size: "15 cm",
            otherImages:
                [
                    {
                        id: 267,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Megumi Fushiguro Figma/megumi-fushiguro-figma_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 268,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Megumi Fushiguro Figma/megumi-fushiguro-figma_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 269,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Megumi Fushiguro Figma/megumi-fushiguro-figma_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 270,
                        imgUrl: require('./productImage/Anime/JujutsuKaisen/Megumi Fushiguro Figma/megumi-fushiguro-figma_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },

    // Naruto 11
    {
        id: 44,
        name: "Uchiha Sasuke",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/Naruto/Uchiha Sasuke/uchiha-sasuke_naruto-shippuden_silo_sm.png'),
        price: 920000,
        categoryID: 4,
        stock: 5,
        details:
        {
            description: "Sasuke thu thập chakra tia chớp trong tay để sử dụng Chidori, lao vào mục tiêu và đâm Chidori vào chúng, xuyên qua chúng và thường gây ra sát thương. Chidori không chỉ ở trong tay mà còn được điều khiển và kéo dài khi chạy nhanh để tạo thành tia chớp xanh bao quanh anh ta. Tư thế được chọn lọc kỹ lưỡng này thể hiện một cách hoàn hảo cảm giác năng động của nhân vật"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Uchiha Sasuke/uchiha-sasuke_naruto-shippuden_feature.jpg'),
            company: "HEX Collectibles",
            material: "Polyresin , Polystone , PVC , PU",
            tagName: ["Anime", "Hành động"],
            size: "49 cm",
            otherImages:
                [
                    {
                        id: 271,
                        imgUrl: require('./productImage/Anime/Naruto/Uchiha Sasuke/uchiha-sasuke_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 272,
                        imgUrl: require('./productImage/Anime/Naruto/Uchiha Sasuke/uchiha-sasuke_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 273,
                        imgUrl: require('./productImage/Anime/Naruto/Uchiha Sasuke/uchiha-sasuke_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 274,
                        imgUrl: require('./productImage/Anime/Naruto/Uchiha Sasuke/uchiha-sasuke_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 45,
        name: "Uchiha Madara",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/Naruto/Uchiha Madara/uchiha-madara_naruto-shippuden_silo_sm.png'),
        price: 920000,
        categoryID: 4,
        stock: 5,
        details:
        {
            description: "Uchiha Madara mặc bộ đồng phục màu tím mang tính biểu tượng của mình với áo giáp đỏ thẫm và nhiều tấm kim loại, tạo thành các vệ sĩ bảo vệ dọc theo ngực, eo, vai và đùi. Tay phải của anh ấy cầm Gunbai Uchiwa, trong đó được làm bằng các nhánh của Shinju. Bụi và những vết nứt bao phủ khuôn mặt của anh ta là biểu tượng của người chết đã được Edo Tensei mang về. Nụ cười tự mãn trên khuôn mặt bộc lộ khía cạnh xấu xa của anh ta"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Uchiha Madara/uchiha-madara_naruto-shippuden_feature.jpg'),
            company: "HEX Collectibles",
            material: "Polyresin , Polystone , PVC , PU",
            tagName: ["Anime", "Hành động"],
            size: "57.9 cm",
            otherImages:
                [
                    {
                        id: 275,
                        imgUrl: require('./productImage/Anime/Naruto/Uchiha Madara/uchiha-madara_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 276,
                        imgUrl: require('./productImage/Anime/Naruto/Uchiha Madara/uchiha-madara_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 277,
                        imgUrl: require('./productImage/Anime/Naruto/Uchiha Madara/uchiha-madara_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 278,
                        imgUrl: require('./productImage/Anime/Naruto/Uchiha Madara/uchiha-madara_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 46,
        name: "Itachi Uchiha (Susanoo Version) With LED Base",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version) With LED Base/itachi-uchiha-susanoo-version-with-led-base_naruto-shippuden_silo_sm.png'),
        price: 820000,
        depositPrice: 200000,
        categoryID: 4,
        stock: 0,
        details:
        {
            description: "Từ bộ anime nổi tiếng Naruto: Shippuden and the Precious G.E.M. series là Itachi Uchiha (Phiên bản Susanoo Với Hình ảnh Sưu tập Cơ sở LED! Susanoo là một hình đại diện hình người đáng sợ được làm hoàn toàn bằng chakra biểu hiện của người dùng. Đây là một kỹ thuật đặc biệt được truyền lại bởi các thành viên của gia tộc Uchiha và là khả năng mạnh nhất hiện có để những người đã đánh thức Mangekyō Sharingan ở cả hai mắt"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version) With LED Base/itachi-uchiha-susanoo-version-with-led-base_naruto-shippuden_feature.jpg'),
            company: "MegaHouse",
            material: "ABS , PVC",
            tagName: ["Anime", "Hành động"],
            size: "38 cm",
            otherImages:
                [
                    {
                        id: 279,
                        imgUrl: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version) With LED Base/itachi-uchiha-susanoo-version-with-led-base_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 280,
                        imgUrl: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version) With LED Base/itachi-uchiha-susanoo-version-with-led-base_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 281,
                        imgUrl: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version) With LED Base/itachi-uchiha-susanoo-version-with-led-base_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 282,
                        imgUrl: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version) With LED Base/itachi-uchiha-susanoo-version-with-led-base_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 47,
        name: "Namikaze Minato vs Kurama",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/Naruto/Namikaze Minato vs Kurama/namikaze-minato-vs-kurama_naruto-shippuden_silo_sm.png'),
        price: 1020000,
        depositPrice: 500000,
        categoryID: 4,
        stock: 0,
        details:
        {
            description: "Cũng giống như khái niệm thương hiệu của HEX Collectibles, họ luôn tìm cách cải tiến các sản phẩm trên thị trường. Tìm cách mới để đẩy ranh giới và nắm bắt bản chất của các nhân vật chúng ta yêu thích và đưa các nhân vật được yêu mến vào cuộc sống theo phong cách năng động mà họ nổi tiếng"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Namikaze Minato vs Kurama/namikaze-minato-vs-kurama_naruto-shippuden_feature.jpg'),
            company: "HEX Collectibles",
            material: "Polystone , PVC , PU",
            tagName: ["Anime", "Hành động"],
            size: "58.9 cm",
            otherImages:
                [
                    {
                        id: 283,
                        imgUrl: require('./productImage/Anime/Naruto/Namikaze Minato vs Kurama/namikaze-minato-vs-kurama_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 284,
                        imgUrl: require('./productImage/Anime/Naruto/Namikaze Minato vs Kurama/namikaze-minato-vs-kurama_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 285,
                        imgUrl: require('./productImage/Anime/Naruto/Namikaze Minato vs Kurama/namikaze-minato-vs-kurama_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 286,
                        imgUrl: require('./productImage/Anime/Naruto/Namikaze Minato vs Kurama/namikaze-minato-vs-kurama_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 48,
        name: "Sakura Haruno (Version 3)",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Naruto/Sakura Haruno (Version 3)/sakura-haruno-version-3_naruto-shippuden_silo_sm.png'),
        price: 720000,
        categoryID: 4,
        stock: 5,
        details:
        {
            description: "Từ bộ anime nổi tiếng Naruto: Shippuden và dòng Naruto Gals DX nổi tiếng, Sakura Haruno Collectible Figure! Được thể hiện ở đây bằng cách sử dụng sức mạnh đặc trưng của cô, Tsunade Senju hay Sức mạnh tăng cường Chakra, cô tập trung chakra của mình vào một điểm duy nhất trên cơ thể và sử dụng nó để tung ra một đòn tàn khốc! Với chiều cao hơn 10,6 inch, cô ấy thể hiện sức mạnh và sự duyên dáng của mình trong một nhân vật anime xinh đẹp. Hãy thêm Sakura vào bộ sưu tập Naruto của bạn ngay hôm nay!"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Sakura Haruno (Version 3)/sakura-haruno-version-3_naruto-shippuden_feature.jpg'),
            company: "MegaHouse",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "27 cm",
            otherImages:
                [
                    {
                        id: 287,
                        imgUrl: require('./productImage/Anime/Naruto/Sakura Haruno (Version 3)/sakura-haruno-version-3_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 288,
                        imgUrl: require('./productImage/Anime/Naruto/Sakura Haruno (Version 3)/sakura-haruno-version-3_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 289,
                        imgUrl: require('./productImage/Anime/Naruto/Sakura Haruno (Version 3)/sakura-haruno-version-3_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 290,
                        imgUrl: require('./productImage/Anime/Naruto/Sakura Haruno (Version 3)/sakura-haruno-version-3_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 49,
        name: "Namikaze Minato",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Naruto/Namikaze Minato/namikaze-minato_naruto-shippuden_silo_sm.png'),
        price: 720000,
        categoryID: 4,
        stock: 7,
        details:
        {
            description: "Minato mặc chiếc áo hori trắng mang tính biểu tượng của anh ấy được điêu khắc với chuyển động linh hoạt, uyển chuyển. Anh ta cầm thanh kunai của Thần Sấm Bay ở tay phải đứng thẳng về phía trước khi đứng trên những viên đá bị nghiền nát, và tập hợp chakra trong lòng bàn tay trái của mình tạo thành Rasengan mạnh mẽ."
            ,
            imageDescription: require('./productImage/Anime/Naruto/Namikaze Minato/namikaze-minato_naruto-shippuden_feature.jpg'),
            company: "HEX Collectibles",
            material: "Polystone , PVC , PU",
            tagName: ["Anime", "Hành động"],
            size: "65 cm",
            otherImages:
                [
                    {
                        id: 291,
                        imgUrl: require('./productImage/Anime/Naruto/Namikaze Minato/namikaze-minato_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 292,
                        imgUrl: require('./productImage/Anime/Naruto/Namikaze Minato/namikaze-minato_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 293,
                        imgUrl: require('./productImage/Anime/Naruto/Namikaze Minato/namikaze-minato_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 294,
                        imgUrl: require('./productImage/Anime/Naruto/Namikaze Minato/namikaze-minato_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 50,
        name: "Naruto Uzumaki (Sage Mode)",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Naruto/Naruto Uzumaki (Sage Mode)/naruto-uzumaki-sage-mode_naruto-shippuden_silo_sm.png'),
        price: 325000,
        categoryID: 4,
        stock: 7,
        details:
        {
            description: "Đứng ở độ cao 7,48 , Naruto được nhìn thấy với nụ cười tinh nghịch và mặc trang phục Chế độ Hiền nhân, cho phép cậu bước vào trạng thái được trao quyền và khai thác các lực lượng tự nhiên của thế giới"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Naruto Uzumaki (Sage Mode)/naruto-uzumaki-sage-mode_naruto-shippuden_feature.jpg'),
            company: "MegaHouse",
            material: "PVC , ABS",
            tagName: ["Anime", "Hành động"],
            size: "19 cm",
            otherImages:
                [
                    {
                        id: 295,
                        imgUrl: require('./productImage/Anime/Naruto/Naruto Uzumaki (Sage Mode)/naruto-uzumaki-sage-mode_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 296,
                        imgUrl: require('./productImage/Anime/Naruto/Naruto Uzumaki (Sage Mode)/naruto-uzumaki-sage-mode_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 297,
                        imgUrl: require('./productImage/Anime/Naruto/Naruto Uzumaki (Sage Mode)/naruto-uzumaki-sage-mode_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 298,
                        imgUrl: require('./productImage/Anime/Naruto/Naruto Uzumaki (Sage Mode)/naruto-uzumaki-sage-mode_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 51,
        name: "Sasuke Uchiha",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Naruto/Sasuke Uchiha/sasuke-uchiha_naruto-shippuden_silo_sm.png'),
        price: 253000,
        categoryID: 4,
        stock: 7,
        details:
        {
            description: "Sasuke Uchiha, như đã thấy trong NARUTO: Shippuden, tái gia nhập S.H.Figuarts với tất cả công nghệ chung mới. Hình hành động bao gồm Cơ thể chính, Ba biểu cảm tùy chọn, Năm cặp tay tùy chọn, Kiếm, Bao kiếm, Kiếm nửa rút, Hiệu ứng Chidori để hiển thị tối ưu!"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Sasuke Uchiha/sasuke-uchiha_naruto-shippuden_feature.jpg'),
            company: "Bandai",
            material: "PVC , ABS",
            tagName: ["Anime", "Hành động"],
            size: "15 cm",
            otherImages:
                [
                    {
                        id: 299,
                        imgUrl: require('./productImage/Anime/Naruto/Sasuke Uchiha/sasuke-uchiha_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 300,
                        imgUrl: require('./productImage/Anime/Naruto/Sasuke Uchiha/sasuke-uchiha_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 301,
                        imgUrl: require('./productImage/Anime/Naruto/Sasuke Uchiha/sasuke-uchiha_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 302,
                        imgUrl: require('./productImage/Anime/Naruto/Sasuke Uchiha/sasuke-uchiha_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 52,
        name: "Itachi Uchiha (Susanoo Version)",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version)/itachi-uchiha-susanoo-version_naruto-shippuden_silo_sm.png'),
        price: 765000,
        categoryID: 4,
        stock: 7,
        details:
        {
            description: "Từ bộ anime nổi tiếng Naruto: Shippuden and the Precious G.E.M. là bộ truyện Sưu tầm Itachi Uchiha (Phiên bản Susanoo)! Susanoo là một avatar hình người đáng sợ được làm hoàn toàn bằng chakra biểu hiện của người dùng. Đây là một kỹ thuật đặc biệt được truyền lại bởi các thành viên của gia tộc Uchiha, và là khả năng mạnh nhất dành cho những ai đã đánh thức Mangekyō Sharingan ở cả hai mắt"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version)/itachi-uchiha-susanoo-version_naruto-shippuden_feature.jpg'),
            company: "MegaHouse",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "38 cm",
            otherImages:
                [
                    {
                        id: 303,
                        imgUrl: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version)/itachi-uchiha-susanoo-version_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 304,
                        imgUrl: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version)/itachi-uchiha-susanoo-version_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 305,
                        imgUrl: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version)/itachi-uchiha-susanoo-version_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 306,
                        imgUrl: require('./productImage/Anime/Naruto/Itachi Uchiha (Susanoo Version)/itachi-uchiha-susanoo-version_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 53,
        name: "Kakashi Hatake DX",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Naruto/Kakashi Hatake DX/kakashi-hatake-dx_naruto-shippuden_silo_sm.png'),
        price: 225000,
        categoryID: 4,
        stock: 7,
        details:
        {
            description: "Từ anime nổi tiếng Naruto: Shippuden xuất hiện một nhân vật Variable Action Heroes DX của Hatake Kakashi! Anh ấy có nhiều bộ phận có thể thay thế cho nhau và khớp nối cao cấp để có thể điều chỉnh tối đa"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Kakashi Hatake DX/kakashi-hatake-dx_naruto-shippuden_feature.jpg'),
            company: "MegaHouse",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "24 cm",
            otherImages:
                [
                    {
                        id: 307,
                        imgUrl: require('./productImage/Anime/Naruto/Kakashi Hatake DX/kakashi-hatake-dx_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 308,
                        imgUrl: require('./productImage/Anime/Naruto/Kakashi Hatake DX/kakashi-hatake-dx_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 309,
                        imgUrl: require('./productImage/Anime/Naruto/Kakashi Hatake DX/kakashi-hatake-dx_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 310,
                        imgUrl: require('./productImage/Anime/Naruto/Kakashi Hatake DX/kakashi-hatake-dx_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 54,
        name: "Sakura Haruno",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Naruto/Sakura Haruno/sakura-haruno_naruto-shippuden_silo_sm.png'),
        price: 225000,
        categoryID: 4,
        stock: 7,
        details:
        {
            description: "Sakura Haruno, như đã thấy trong NARUTO: Shippuden, tái gia nhập S.H.Figuarts với tất cả công nghệ chung mới. Hình hành động bao gồm Thân chính, Ba bàn tay trái và hai tay phải tùy chọn, Bốn biểu thức tùy chọn, Bộ phận hiệu ứng bàn tay để hiển thị tối ưu!"
            ,
            imageDescription: require('./productImage/Anime/Naruto/Sakura Haruno/sakura-haruno_naruto-shippuden_feature.jpg'),
            company: "Bandai",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "14 cm",
            otherImages:
                [
                    {
                        id: 311,
                        imgUrl: require('./productImage/Anime/Naruto/Sakura Haruno/sakura-haruno_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 312,
                        imgUrl: require('./productImage/Anime/Naruto/Sakura Haruno/sakura-haruno_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 313,
                        imgUrl: require('./productImage/Anime/Naruto/Sakura Haruno/sakura-haruno_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 314,
                        imgUrl: require('./productImage/Anime/Naruto/Sakura Haruno/sakura-haruno_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },


    // One Piece 13
    {
        id: 55,
        name: "Aokiji Kuzan",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/OnePiece/Aokiji Kuzan/aokiji-kuzan_one-piece_silo_sm.png'),
        price: 725000,
        categoryID: 3,
        stock: 7,
        details:
        {
            description: "Bức tượng này dựa trên Kuzan, và sự xuất hiện của anh ấy giống như Dressrosa Saga. Bây giờ đã nghỉ hưu từ Thủy quân lục chiến, Kuzan sở hữu khả năng lái xe và tầm nhìn xa hơn so với trước đây. Bức tượng mô tả cảnh biển đóng băng và bầu trời tuyết rơi. Kuzan đã dừng xe và hạ cánh bằng một chân."
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Aokiji Kuzan/aokiji-kuzan_one-piece_feature.jpg'),
            company: "Jimei Palace",
            material: "Resin",
            tagName: ["Anime", "Hành động"],
            size: "50 cm",
            otherImages:
                [
                    {
                        id: 315,
                        imgUrl: require('./productImage/Anime/OnePiece/Aokiji Kuzan/aokiji-kuzan_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 316,
                        imgUrl: require('./productImage/Anime/OnePiece/Aokiji Kuzan/aokiji-kuzan_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 317,
                        imgUrl: require('./productImage/Anime/OnePiece/Aokiji Kuzan/aokiji-kuzan_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 318,
                        imgUrl: require('./productImage/Anime/OnePiece/Aokiji Kuzan/aokiji-kuzan_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 56,
        name: "Borsalino Kizaru",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/OnePiece/Borsalino Kizaru/borsalino-kizaru_one-piece_silo_sm.png'),
        price: 825000,
        depositPrice: 350000,
        categoryID: 3,
        stock: 0,
        details:
        {
            description: "Borsalino, phần lớn được công nhận bởi bí danh Kizaru, một trong ba đô đốc của Thủy quân lục chiến, đã ăn Trái Pika Pika loại Logia giúp anh có khả năng biến thành ánh sáng và chế tạo vũ khí ngoài ánh sáng. Sự bình tĩnh, thoải mái và không quan tâm đến xung quanh của anh ấy đã gây ấn tượng sâu sắc với nhiều người hâm mộ ONE PIECE."
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Borsalino Kizaru/borsalino-kizaru_one-piece_feature.jpg'),
            company: "Jimei Palace",
            material: "Resin",
            tagName: ["Anime", "Hành động"],
            size: "70 cm",
            otherImages:
                [
                    {
                        id: 319,
                        imgUrl: require('./productImage/Anime/OnePiece/Borsalino Kizaru/borsalino-kizaru_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 320,
                        imgUrl: require('./productImage/Anime/OnePiece/Borsalino Kizaru/borsalino-kizaru_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 321,
                        imgUrl: require('./productImage/Anime/OnePiece/Borsalino Kizaru/borsalino-kizaru_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 322,
                        imgUrl: require('./productImage/Anime/OnePiece/Borsalino Kizaru/borsalino-kizaru_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 57,
        name: "Kaido",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/OnePiece/Kaido/kaido_one-piece_silo_sm.png'),
        price: 825000,
        categoryID: 3,
        stock: 2,
        details:
        {
            description: "Có chiều cao khủng và rất cơ bắp, với kiểu tóc hoang dã và phóng túng, nhân vật phản diện này có một cặp sừng trên đầu, râu dài như râu rồng và trên cánh tay trái có hình xăm vảy rồng. Phần trên của anh ấy để trần, với một vết sẹo chéo ở bụng bên phải, một chiếc áo sơ mi màu tím được treo ở eo và một chiếc áo shimenawa dày được buộc quanh eo"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Kaido/kaido_one-piece_feature.jpg'),
            company: "Jimei Palace",
            material: "Resin",
            tagName: ["Anime", "Hành động"],
            size: "75 cm",
            otherImages:
                [
                    {
                        id: 323,
                        imgUrl: require('./productImage/Anime/OnePiece/Kaido/kaido_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 324,
                        imgUrl: require('./productImage/Anime/OnePiece/Kaido/kaido_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 325,
                        imgUrl: require('./productImage/Anime/OnePiece/Kaido/kaido_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 326,
                        imgUrl: require('./productImage/Anime/OnePiece/Kaido/kaido_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 58,
        name: "Perona",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/OnePiece/Perona/perona_one-piece_silo_sm.png'),
        price: 750000,
        categoryID: 3,
        stock: 2,
        details:
        {
            description: "Công chúa Perona được giới thiệu ở đây như là sự xuất hiện của cô ấy từ anime và manga được yêu thích trước timeskip. Khung cảnh ruộng bậc thang được tạo nên từ kiến ​​trúc đáng sợ và những con búp bê mang tính biểu tượng của Perona, mặc dù bia mộ và cây cối được vẽ theo phong cách kỳ quái nhưng những con sóc lại làm cho toàn bộ khung cảnh trở nên sinh động và thú vị và dám ... dễ thương?"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Perona/perona_one-piece_feature.jpg'),
            company: "Jimei Palace",
            material: "Resin",
            tagName: ["Anime", "Hành động"],
            size: "49 cm",
            otherImages:
                [
                    {
                        id: 327,
                        imgUrl: require('./productImage/Anime/OnePiece/Perona/perona_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 328,
                        imgUrl: require('./productImage/Anime/OnePiece/Perona/perona_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 329,
                        imgUrl: require('./productImage/Anime/OnePiece/Perona/perona_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 330,
                        imgUrl: require('./productImage/Anime/OnePiece/Perona/perona_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 59,
        name: "Monkey D. Luffy (Wano Country - Third Act)",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/OnePiece/Monkey D. Luffy (Wano Country - Third Act)/monkey-d-luffy-wano-country-third-act_one-piece_silo_sm.png'),
        price: 400000,
        categoryID: 3,
        stock: 7,
        details:
        {
            description: "Bandai Spirits Ichibansho tự hào thông báo bản phát hành mới nhất Monkey.D.Luffy (Wano Country - Third Act) của họ! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Monkey.D.Luffy trong anime tương ứng của họ. Cao khoảng 7,9 inch, Monkey.D.Luffy được nhìn thấy trong tư thế phổ biến của họ"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Monkey D. Luffy (Wano Country - Third Act)/monkey-d-luffy-wano-country-third-act_one-piece_feature.jpg'),
            company: "Bandai",
            material: "Resin",
            tagName: ["Anime", "Hành động"],
            size: "21.1 cm",
            otherImages:
                [
                    {
                        id: 331,
                        imgUrl: require('./productImage/Anime/OnePiece/Monkey D. Luffy (Wano Country - Third Act)/monkey-d-luffy-wano-country-third-act_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 332,
                        imgUrl: require('./productImage/Anime/OnePiece/Monkey D. Luffy (Wano Country - Third Act)/monkey-d-luffy-wano-country-third-act_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 333,
                        imgUrl: require('./productImage/Anime/OnePiece/Monkey D. Luffy (Wano Country - Third Act)/monkey-d-luffy-wano-country-third-act_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 334,
                        imgUrl: require('./productImage/Anime/OnePiece/Monkey D. Luffy (Wano Country - Third Act)/monkey-d-luffy-wano-country-third-act_one-piece_gallery_1.jpg'),
                    },
                ],

        }
    },
    {
        id: 60,
        name: "Roronoa Zoro VS Hawkins",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/OnePiece/Roronoa Zoro VS Hawkins/roronoa-zoro-vs-hawkins_one-piece_silo_sm.png'),
        price: 720000,
        depositPrice: 200000,
        categoryID: 3,
        stock: 0,
        details:
        {
            description: "Bức tượng này thể hiện một khung cảnh được lấy cảm hứng từ và dựa trên cuộc chiến của Roronoa chống lại Basil Hawkins và con bù nhìn mạnh mẽ của hắn. Ngọn lửa đỏ của nền tảng được phân lớp cao, thu được hiệu ứng từ anime khi cả hai chiến binh đang sử dụng hết khả năng của mình. Điêu khắc bù nhìn rất tỉ mỉ, nét vẽ trên tay rất ngầu và rạng rỡ, đường nét và kết cấu của rơm không trộn lẫn mà tinh tế, cùng với hiệu ứng phát sáng của mắt làm cho toàn bộ bù nhìn sống động như thật"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Roronoa Zoro VS Hawkins/roronoa-zoro-vs-hawkins_one-piece_feature.jpg'),
            company: "Jimei Palace",
            material: "Resin",
            tagName: ["Anime", "Hành động"],
            size: "60 cm",
            otherImages:
                [
                    {
                        id: 335,
                        imgUrl: require('./productImage/Anime/OnePiece/Roronoa Zoro VS Hawkins/roronoa-zoro-vs-hawkins_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 336,
                        imgUrl: require('./productImage/Anime/OnePiece/Roronoa Zoro VS Hawkins/roronoa-zoro-vs-hawkins_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 337,
                        imgUrl: require('./productImage/Anime/OnePiece/Roronoa Zoro VS Hawkins/roronoa-zoro-vs-hawkins_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 338,
                        imgUrl: require('./productImage/Anime/OnePiece/Roronoa Zoro VS Hawkins/roronoa-zoro-vs-hawkins_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 61,
        name: "Yamato - Raimei Hakke (Extra Battle)",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/OnePiece/Yamato - Raimei Hakke (Extra Battle)/yamato-raimei-hakke-extra-battle_one-piece_silo_sm.png'),
        price: 320000,
        categoryID: 3,
        stock: 10,
        details:
        {
            description: "YAMATO, samurai hung dữ của bộ truyện One Piece, tham gia Figuarts ZERO! Xoay cây gậy sắt khổng lồ của mình, cô ấy tung ra đòn tấn công sấm sét RAIMEI HAKKE của mình! Nhân vật có tư thế cố định này sử dụng các chi tiết điêu khắc và trong mờ tinh tế để đưa bạn vào giữa hành động!"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Yamato - Raimei Hakke (Extra Battle)/yamato-raimei-hakke-extra-battle_one-piece_feature.jpg'),
            company: "Bandai",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "16 cm",
            otherImages:
                [
                    {
                        id: 339,
                        imgUrl: require('./productImage/Anime/OnePiece/Yamato - Raimei Hakke (Extra Battle)/yamato-raimei-hakke-extra-battle_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 340,
                        imgUrl: require('./productImage/Anime/OnePiece/Yamato - Raimei Hakke (Extra Battle)/yamato-raimei-hakke-extra-battle_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 341,
                        imgUrl: require('./productImage/Anime/OnePiece/Yamato - Raimei Hakke (Extra Battle)/yamato-raimei-hakke-extra-battle_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 342,
                        imgUrl: require('./productImage/Anime/OnePiece/Yamato - Raimei Hakke (Extra Battle)/yamato-raimei-hakke-extra-battle_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 62,
        name: "Portrait of Pirates “Heavenly Demon” Donquixote Doflamingo",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/OnePiece/Portrait of Pirates “Heavenly Demon” Donquixote Doflamingo/portrait-of-pirates-heavenly-demon-donquixote-doflamingo_one-piece_silo_sm.png'),
        price: 420000,
        categoryID: 3,
        stock: 10,
        details:
        {
            description: "Những lời kêu gọi Donquixote Doflamingo tham gia loạt phim P.O.P đã đến từ cả Nhật Bản và nước ngoài, và các yêu cầu đã được nhà điêu khắc MAS trả lời với tác phẩm sơn của Kenji Ando, ​​người đã chụp lại Donquixote táo bạo với những chi tiết tinh tế để người hâm mộ thêm vào bộ sưu tập của họ!"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Portrait of Pirates “Heavenly Demon” Donquixote Doflamingo/portrait-of-pirates-heavenly-demon-donquixote-doflamingo_one-piece_feature.jpg'),
            company: "Mega House",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "34.5 cm",
            otherImages:
                [
                    {
                        id: 343,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates “Heavenly Demon” Donquixote Doflamingo/portrait-of-pirates-heavenly-demon-donquixote-doflamingo_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 344,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates “Heavenly Demon” Donquixote Doflamingo/portrait-of-pirates-heavenly-demon-donquixote-doflamingo_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 345,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates “Heavenly Demon” Donquixote Doflamingo/portrait-of-pirates-heavenly-demon-donquixote-doflamingo_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 346,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates “Heavenly Demon” Donquixote Doflamingo/portrait-of-pirates-heavenly-demon-donquixote-doflamingo_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 63,
        name: "Luffy Taro Warriors Alliance",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/OnePiece/Luffy Taro Warriors Alliance/luffy-taro-warriors-alliance_one-piece_silo_sm.png'),
        price: 420000,
        categoryID: 3,
        stock: 10,
        details:
        {
            description: "Luffy gia nhập đội Liên minh Chiến binh từ MegaHouse, với biệt danh Luffy Taro! Mặc một bộ trang phục lấy cảm hứng từ ronin, nhân vật này cao khoảng 6,7 inch, tạo dáng để chiến đấu với đối thủ của mình"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Luffy Taro Warriors Alliance/luffy-taro-warriors-alliance_one-piece_feature.jpg'),
            company: "Mega House",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "17 cm",
            otherImages:
                [
                    {
                        id: 347,
                        imgUrl: require('./productImage/Anime/OnePiece/Luffy Taro Warriors Alliance/luffy-taro-warriors-alliance_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 348,
                        imgUrl: require('./productImage/Anime/OnePiece/Luffy Taro Warriors Alliance/luffy-taro-warriors-alliance_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 349,
                        imgUrl: require('./productImage/Anime/OnePiece/Luffy Taro Warriors Alliance/luffy-taro-warriors-alliance_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 350,
                        imgUrl: require('./productImage/Anime/OnePiece/Luffy Taro Warriors Alliance/luffy-taro-warriors-alliance_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 64,
        name: "Portrait of Pirates Sabo Fire Fist Inheritance",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/OnePiece/Portrait of Pirates Sabo Fire Fist Inheritance/portrait-of-pirates-sabo-fire-fist-inheritance_one-piece_silo_sm.png'),
        price: 320000,
        categoryID: 3,
        stock: 10,
        details:
        {
            description: "Sabo được đoàn tụ với Luffy tại Đấu trường La Mã Corrida, nơi cậu cho thấy mình được thừa hưởng sức mạnh của Mera Mera no Mi cùng với ý chí của Ace." +
                "Anh ấy đã được điêu khắc bằng khả năng Hiken trong một tư thế năng động cùng với biểu cảm đầy thuyết phục thể hiện cá tính của anh ấy khiến người hâm mộ thích thú. Một con số chất lượng cao đầy những điểm nổi bật!"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Portrait of Pirates Sabo Fire Fist Inheritance/portrait-of-pirates-sabo-fire-fist-inheritance_one-piece_feature.jpg'),
            company: "Mega House",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "14.5 cm",
            otherImages:
                [
                    {
                        id: 351,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates Sabo Fire Fist Inheritance/portrait-of-pirates-sabo-fire-fist-inheritance_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 352,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates Sabo Fire Fist Inheritance/portrait-of-pirates-sabo-fire-fist-inheritance_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 353,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates Sabo Fire Fist Inheritance/portrait-of-pirates-sabo-fire-fist-inheritance_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 354,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates Sabo Fire Fist Inheritance/portrait-of-pirates-sabo-fire-fist-inheritance_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 65,
        name: "Portrait of Pirates Warriors Alliance Oden Kozuki",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/OnePiece/Portrait of Pirates Warriors Alliance Oden Kozuki/portrait-of-pirates-warriors-alliance-oden-kozuki_one-piece_silo_sm.png'),
        price: 450000,
        categoryID: 3,
        stock: 10,
        details:
        {
            description: "Phần bổ sung mới nhất cho loạt P.O.P ONE PIECE Warriors Alliance là người thừa kế của Mạc phủ của Wano Country và daimyo của Kuri, Oden Mitsuki! Kozuki trong tư thế sử dụng hai trong số 21 thanh kiếm Đại cấp, Ame no Habakiri và Enma, thể hiện Phong cách hai thanh kiếm Oden ấn tượng của mình trong hình dạng nhân vật."
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Portrait of Pirates Warriors Alliance Oden Kozuki/portrait-of-pirates-warriors-alliance-oden-kozuki_one-piece_feature.jpg'),
            company: "Mega House",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "27.5 cm",
            otherImages:
                [
                    {
                        id: 355,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates Warriors Alliance Oden Kozuki/portrait-of-pirates-warriors-alliance-oden-kozuki_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 356,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates Warriors Alliance Oden Kozuki/portrait-of-pirates-warriors-alliance-oden-kozuki_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 357,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates Warriors Alliance Oden Kozuki/portrait-of-pirates-warriors-alliance-oden-kozuki_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 358,
                        imgUrl: require('./productImage/Anime/OnePiece/Portrait of Pirates Warriors Alliance Oden Kozuki/portrait-of-pirates-warriors-alliance-oden-kozuki_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 66,
        name: "Roronoa Zoro (WT100 Commemorative Eiichiro Oda Illustration DAIKAIZOKU HYAKKEI)",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/OnePiece/Roronoa Zoro/roronoa-zoro-wt100-commemorative-eiichiro-oda-illustration-daikaizoku-hyakkei_one-piece_silo_sm.png'),
        price: 465000,
        categoryID: 3,
        stock: 10,
        details:
        {
            description: "Dựa trên Hình minh họa WT100 động của Eiichiro Oda để kỷ niệm Roronoa Zoro được bầu chọn đứng thứ hai trong cuộc bình chọn Nhân vật nổi tiếng thế giới One Piece đầu tiên trên toàn cầu Cuộc bình chọn TOP 100 THẾ GIỚI! Roronoa Zoro tham gia Figuarts ZERO trong một kích thước mới đặc biệt!"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Roronoa Zoro/roronoa-zoro-feature.jpg'),
            company: "Bandai",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "17 cm",
            otherImages:
                [
                    {
                        id: 359,
                        imgUrl: require('./productImage/Anime/OnePiece/Roronoa Zoro/roronoa-zoro-gallery_1.jpg'),
                    },
                    {
                        id: 360,
                        imgUrl: require('./productImage/Anime/OnePiece/Roronoa Zoro/roronoa-zoro_gallery_2.jpg'),
                    },
                    {
                        id: 361,
                        imgUrl: require('./productImage/Anime/OnePiece/Roronoa Zoro/roronoa-zoro_gallery_3.jpg'),
                    },
                    {
                        id: 362,
                        imgUrl: require('./productImage/Anime/OnePiece/Roronoa Zoro/roronoa-zoro_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 67,
        name: "Yamato (Glitter of Ha)",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/OnePiece/Yamato (Glitter of Ha)/yamato-glitter-of-ha_one-piece_silo_sm.png'),
        price: 465000,
        categoryID: 3,
        stock: 10,
        details:
        {
            description: "Yamato (Glitter of Ha) Hình sưu tầm! Bức tượng này được chế tác một cách chuyên nghiệp và điêu khắc tỉ mỉ để trông giống như Yamato trong anime tương ứng của họ. Với chiều cao xấp xỉ 7,9 , Yamato được nhìn thấy trong tư thế phổ biến của họ. Hãy nhớ thu thập điều này và nâng cao màn hình của bạn với các nhân vật Ichibansho đáng kinh ngạc khác!"
            ,
            imageDescription: require('./productImage/Anime/OnePiece/Yamato (Glitter of Ha)/yamato-glitter-of-ha_one-piece_feature.jpg'),
            company: "Bandai",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "20 cm",
            otherImages:
                [
                    {
                        id: 363,
                        imgUrl: require('./productImage/Anime/OnePiece/Yamato (Glitter of Ha)/yamato-glitter-of-ha_one-piece_gallery_1.jpg'),
                    },
                    {
                        id: 364,
                        imgUrl: require('./productImage/Anime/OnePiece/Yamato (Glitter of Ha)/yamato-glitter-of-ha_one-piece_gallery_2.jpg'),
                    },
                    {
                        id: 365,
                        imgUrl: require('./productImage/Anime/OnePiece/Yamato (Glitter of Ha)/yamato-glitter-of-ha_one-piece_gallery_3.jpg'),
                    },
                    {
                        id: 366,
                        imgUrl: require('./productImage/Anime/OnePiece/Yamato (Glitter of Ha)/yamato-glitter-of-ha_one-piece_gallery_4.jpg'),
                    },
                ],

        }
    },

    //Demon Slayer
    {
        id: 68,
        name: "Inosuke Hashibira",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Kimetsu/Inosuke Hashibira/inosuke-hashibira_demon-slayer_silo_sm.png'),
        price: 375000,
        categoryID: 5,
        stock: 10,
        details:
        {
            description: " Bản chất hoang dã của Inosuke được ghi lại một cách hoàn hảo khi anh ta thể hiện một tư thế hung hãn sẵn sàng tham gia cuộc chiến với hai thanh kiếm Nichirin của mình. Hình vẽ có các chi tiết đáng kinh ngạc bao gồm vóc dáng cực kỳ cơ bắp của anh ấy và những lớp vỏ bọc bị phong hóa xung quanh chuôi kiếm của anh ấy"
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Inosuke Hashibira/inosuke-hashibira_demon-slayer_feature.jpg'),
            company: "Aniplex",
            material: "PVC, ABS",
            tagName: ["Anime", "Hành động"],
            size: "16 cm",
            otherImages:
                [
                    {
                        id: 367,
                        imgUrl: require('./productImage/Anime/Kimetsu/Inosuke Hashibira/inosuke-hashibira_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 368,
                        imgUrl: require('./productImage/Anime/Kimetsu/Inosuke Hashibira/inosuke-hashibira_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 369,
                        imgUrl: require('./productImage/Anime/Kimetsu/Inosuke Hashibira/inosuke-hashibira_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 370,
                        imgUrl: require('./productImage/Anime/Kimetsu/Inosuke Hashibira/inosuke-hashibira_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 69,
        name: "Kamado Nezuko",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Kimetsu/Kamado Nezuko/kamado-nezuko_demon-slayer_silo_sm.png'),
        price: 115000,
        categoryID: 5,
        stock: 15,
        details:
        {
            description: "Từ Demon Slayer: Kimetsu no Yaiba, Kamado Nezuko tham gia Figuarts ZERO! Được thiết kế để gợi nhớ cô ấy chạy trốn khi còn là một cô bé, nhân vật anime này thể hiện tất cả sự năng động trong ngoại hình của cô ấy với các phần hiệu ứng và các chi tiết đẹp từ mái tóc đến chân của cô ấy. Bộ sưu tập Nezuko Kamado cũng bao gồm các phần biểu cảm ấn tượng!"
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Kamado Nezuko/kamado-nezuko_demon-slayer_feature.jpg'),
            company: "Bandai",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "11 cm",
            otherImages:
                [
                    {
                        id: 371,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kamado Nezuko/kamado-nezuko_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 372,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kamado Nezuko/kamado-nezuko_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 373,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kamado Nezuko/kamado-nezuko_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 374,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kamado Nezuko/kamado-nezuko_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 70,
        name: "Kamado Tanjiro (Hinokami Kagura)",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Kimetsu/Kamado Tanjiro (Hinokami Kagura)/kamado-tanjiro-hinokami-kagura_demon-slayer_silo_sm.png'),
        price: 752800,
        categoryID: 5,
        stock: 15,
        details:
        {
            description: "Từ Demon Slayer: Kimetsu no Yaiba, Kamado Tanjiro nhảy Hinokami Kagura, Vũ điệu của Thần lửa, tham gia Figuarts ZERO! Các bộ phận hiệu ứng ấn tượng được sử dụng để tái tạo vũ điệu động trong không gian ba chiều, đến từng chi tiết nhỏ nhất để gợi lên một lượng cảm giác đáng kinh ngạc!"
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Kamado Tanjiro (Hinokami Kagura)/kamado-tanjiro-hinokami-kagura_demon-slayer_feature.jpg'),
            company: "Bandai",
            material: "PVC",
            tagName: ["Anime", "Hành động"],
            size: "21 cm",
            otherImages:
                [
                    {
                        id: 375,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kamado Tanjiro (Hinokami Kagura)/kamado-tanjiro-hinokami-kagura_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 376,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kamado Tanjiro (Hinokami Kagura)/kamado-tanjiro-hinokami-kagura_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 377,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kamado Tanjiro (Hinokami Kagura)/kamado-tanjiro-hinokami-kagura_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 378,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kamado Tanjiro (Hinokami Kagura)/kamado-tanjiro-hinokami-kagura_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 71,
        name: "Kyojuro Rengoku",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku/kyojuro-rengoku_demon-slayer_silo_sm.png'),
        price: 752800,
        categoryID: 5,
        stock: 7,
        details:
        {
            description: "Từ anime, Sát quỷ kiếm: Kimetsu no Yaiba, Ngọn lửa Hashira, Kyojuro Rengoku, trở nên sống động khi anh ta hạ kiếm của mình trong một cuộc tấn công năng động." +
                "Tác phẩm điêu khắc của haori cuồn cuộn mà anh ta mặc dường như sống động với chuyển động khi người ta chăm chút nhiều vào độ rung của vải cho mỗi ngọn lửa trên viền áo haori. Cùng với những ngọn lửa được điêu khắc trên đế, đây là một vật phẩm chứa đầy nhiệt độ bùng cháy"
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku/kyojuro-rengoku_demon-slayer_feature.jpg'),
            company: "Kotobukiya",
            material: "PVC, ABS",
            tagName: ["Anime", "Hành động"],
            size: "22.5 cm",
            otherImages:
                [
                    {
                        id: 379,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku/kyojuro-rengoku_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 380,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku/kyojuro-rengoku_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 381,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku/kyojuro-rengoku_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 382,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku/kyojuro-rengoku_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 72,
        name: "Kyojuro Rengoku Deluxe Version",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku Deluxe Version/kyojuro-rengoku-deluxe-version_demon-slayer_silo_sm.png'),
        price: 958000,
        depositPrice: 250000,
        categoryID: 5,
        stock: 0,
        details:
        {
            description: "Hình vẽ được ba chiều hóa với vẻ ngoài sống động, tưởng tượng hình ảnh một con quỷ đang đối mặt với một con quỷ khi đang cầm Nichirin Blades. Chúng tôi rất đặc biệt chú trọng đến việc tạo mẫu để sức mạnh của Kyojuro Rengoku có thể được tăng cường toàn diện, chẳng hạn như kiểu tóc đặc trưng, ​​áo choàng bay bổng và các mạch máu nổi lên trên trán và mu bàn tay"
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku Deluxe Version/kyojuro-rengoku-deluxe-version_demon-slayer_feature.jpg'),
            company: "Bellfine",
            material: "PVC, ABS",
            tagName: ["Anime", "Hành động"],
            size: "35 cm",
            otherImages:
                [
                    {
                        id: 383,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku Deluxe Version/kyojuro-rengoku-deluxe-version_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 384,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku Deluxe Version/kyojuro-rengoku-deluxe-version_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 385,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku Deluxe Version/kyojuro-rengoku-deluxe-version_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 386,
                        imgUrl: require('./productImage/Anime/Kimetsu/Kyojuro Rengoku Deluxe Version/kyojuro-rengoku-deluxe-version_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 73,
        name: "Shinobu Kocho",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/Kimetsu/Shinobu Kocho/shinobu-kocho_demon-slayer_silo_sm.png'),
        price: 452600,
        categoryID: 5,
        stock: 6,
        details:
        {
            description: "Những đầu ngón tay thon gọn của Shinobu và haori thổi trong gió được điêu khắc tinh xảo. Tượng đứng trên đỉnh động có họa tiết hình con bướm nổi. Từ phụ kiện tóc đến chuôi kiếm Nichirin Blade, từng chi tiết trong thiết kế của Shinobu đều được tái tạo một cách chân thực. Bức tượng này thể hiện hoàn hảo vẻ đẹp và phong thái vui vẻ của Shinobu Kocho"
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Shinobu Kocho/shinobu-kocho_demon-slayer_feature.jpg'),
            company: "Kotobukiya",
            material: "PVC, ABS",
            tagName: ["Anime", "Hành động"],
            size: "25.2 cm",
            otherImages:
                [
                    {
                        id: 387,
                        imgUrl: require('./productImage/Anime/Kimetsu/Shinobu Kocho/shinobu-kocho_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 388,
                        imgUrl: require('./productImage/Anime/Kimetsu/Shinobu Kocho/shinobu-kocho_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 389,
                        imgUrl: require('./productImage/Anime/Kimetsu/Shinobu Kocho/shinobu-kocho_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 390,
                        imgUrl: require('./productImage/Anime/Kimetsu/Shinobu Kocho/shinobu-kocho_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 74,
        name: "Shinobu Kocho",
        tagName: ["Anime", "Hành động"],
        status: "preOrder",
        thumbImg: require('./productImage/Anime/Kimetsu/Shinobu Kochov2/shinobu-kocho_demon-slayer_silo_sm.png'),
        price: 625000,
        depositPrice: 350000,
        categoryID: 5,
        stock: 0,
        details:
        {
            description: "Từ loạt phim đình đám Demon Slayer: Kimetsu No Yaiba, Shinobu Kocho duyên dáng đã ra mắt Aniplex + của cô ấy! Hình tỷ lệ 1: 8 tuyệt đẹp này có hình ảnh Shinobu trong tư thế bất chấp trọng lực khi những con bướm dường như đang mang cô ấy. Các chi tiết trên hiệu ứng con bướm trong suốt kết hợp với nụ cười tuyệt đẹp trên khuôn mặt của cô ấy mang đến cho các nhà sưu tập hình ảnh thanh lịch thể hiện bản chất của Shinobu!"
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Shinobu Kochov2/shinobu-kocho_demon-slayer_feature.jpg'),
            company: "Kotobukiya",
            material: "PVC, ABS",
            tagName: ["Anime", "Hành động"],
            size: "25.2 cm",
            otherImages:
                [
                    {
                        id: 391,
                        imgUrl: require('./productImage/Anime/Kimetsu/Shinobu Kochov2/shinobu-kocho_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 392,
                        imgUrl: require('./productImage/Anime/Kimetsu/Shinobu Kochov2/shinobu-kocho_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 393,
                        imgUrl: require('./productImage/Anime/Kimetsu/Shinobu Kochov2/shinobu-kocho_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 394,
                        imgUrl: require('./productImage/Anime/Kimetsu/Shinobu Kochov2/shinobu-kocho_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 75,
        name: "Tengen Uzui",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/Kimetsu/Tengen Uzui/tengen-uzui_demon-slayer_silo_sm.png'),
        price: 550000,
        categoryID: 5,
        stock: 6,
        details:
        {
            description: "Tengen Uzui từ series anime nổi tiếng Kimetsu no Yaiba: Demon Slayer tham gia FiguartsZERO. Anh ấy đang tạo dáng trong một cảnh động với những thanh kiếm được xích đặc trưng của anh ấy."
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Tengen Uzui/tengen-uzui_demon-slayer_feature.jpg'),
            company: "Bandai",
            material: "PVC, ABS",
            tagName: ["Anime", "Hành động"],
            size: "14 cm",
            otherImages:
                [
                    {
                        id: 395,
                        imgUrl: require('./productImage/Anime/Kimetsu/Tengen Uzui/tengen-uzui_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 396,
                        imgUrl: require('./productImage/Anime/Kimetsu/Tengen Uzui/tengen-uzui_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 397,
                        imgUrl: require('./productImage/Anime/Kimetsu/Tengen Uzui/tengen-uzui_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 398,
                        imgUrl: require('./productImage/Anime/Kimetsu/Tengen Uzui/tengen-uzui_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 76,
        name: "Tomioka Giyu - Water Breathing",
        tagName: ["Anime", "Hành động"],
        status: "new",
        thumbImg: require('./productImage/Anime/Kimetsu/Tomioka Giyu - Water Breathing/tomioka-giyu-water-breathing_demon-slayer_silo_sm.png'),
        price: 550000,
        categoryID: 5,
        stock: 6,
        details:
        {
            description: "Các phần hiệu ứng trong mờ tạo nên sự thể hiện ba chiều động của kỹ thuật Thở bằng nước của Tomioka Giyu. Bao gồm các chi tiết trung thực như quần áo có hoa văn chân thực và chữ khắc trên thanh kiếm"
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Tomioka Giyu - Water Breathing/tomioka-giyu-water-breathing_demon-slayer_feature.jpg'),
            company: "Bandai",
            material: "PVC, ABS",
            tagName: ["Anime", "Hành động"],
            size: "16 cm",
            otherImages:
                [
                    {
                        id: 399,
                        imgUrl: require('./productImage/Anime/Kimetsu/Tomioka Giyu - Water Breathing/tomioka-giyu-water-breathing_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 400,
                        imgUrl: require('./productImage/Anime/Kimetsu/Tomioka Giyu - Water Breathing/tomioka-giyu-water-breathing_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 401,
                        imgUrl: require('./productImage/Anime/Kimetsu/Tomioka Giyu - Water Breathing/tomioka-giyu-water-breathing_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 402,
                        imgUrl: require('./productImage/Anime/Kimetsu/Tomioka Giyu - Water Breathing/tomioka-giyu-water-breathing_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 77,
        name: "Zenitsu Agatsuma Thunderclap and Flash",
        tagName: ["Anime", "Hành động"],
        status: "available",
        thumbImg: require('./productImage/Anime/Kimetsu/Zenitsu Agatsuma Thunderclap and Flash/zenitsu-agatsuma-thunderclap-and-flash_dc-comics_silo_sm.png'),
        price: 550000,
        categoryID: 5,
        stock: 6,
        details:
        {
            description: "From the smash hit Demon Slayer: Kimetsu no Yaiba, Zenitsu Agatsuma joins FiguartsZERO releasing his Thunderclap and Flash attack! Standing at 5.9 inches, the anime figure uses translucent effect parts to highlight the drama of his flashy finishing move."
            ,
            imageDescription: require('./productImage/Anime/Kimetsu/Zenitsu Agatsuma Thunderclap and Flash/zenitsu-agatsuma-thunderclap-and-flash_dc-comics_feature.jpg'),
            company: "Bandai",
            material: "PVC, ABS",
            tagName: ["Anime", "Hành động"],
            size: "15 cm",
            otherImages:
                [
                    {
                        id: 403,
                        imgUrl: require('./productImage/Anime/Kimetsu/Zenitsu Agatsuma Thunderclap and Flash/zenitsu-agatsuma-thunderclap-and-flash_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 404,
                        imgUrl: require('./productImage/Anime/Kimetsu/Zenitsu Agatsuma Thunderclap and Flash/zenitsu-agatsuma-thunderclap-and-flash_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 405,
                        imgUrl: require('./productImage/Anime/Kimetsu/Zenitsu Agatsuma Thunderclap and Flash/zenitsu-agatsuma-thunderclap-and-flash_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 406,
                        imgUrl: require('./productImage/Anime/Kimetsu/Zenitsu Agatsuma Thunderclap and Flash/zenitsu-agatsuma-thunderclap-and-flash_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },

    //Genshin
    {
        id: 78,
        name: "Astral Reflection Mona",
        tagName: ["Anime", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Genshin/Astral Reflection Mona/astral-reflection-mona_genshin-impact_silo_sm.png'),
        price: 752000,
        depositPrice: 342000,
        categoryID: 11,
        stock: 0,
        details:
        {
            description: "Từ trò chơi RPG thế giới mở Genshin Impact, nhân vật tỷ lệ 1/7 của Nhà chiêm tinh vĩ đại Mona! Với Mona xuất hiện từ chiếc áo choàng của Illusory Torrent, phong cách chiến đấu độc đáo của cô ấy đã được ghi lại một cách trung thực trong hình dạng nhân vật. " +

                "Tư thế uyển chuyển của Mona, các kết cấu khác nhau của bộ trang phục độc đáo, phụ kiện theo chủ đề ngôi sao và hiệu ứng nước dưới chân cô ấy đều được tái tạo một cách cẩn thận từng chi tiết, tạo nên một sự tái hiện quyến rũ về người bí ẩn, kiêu hãnh, thông minh, chu đáo và cũng nhà chiêm tinh hơi kém (?)! Hãy chắc chắn thêm cô ấy vào bộ sưu tập của bạn!"
            ,
            imageDescription: require('./productImage/Genshin/Astral Reflection Mona/astral-reflection-mona_genshin-impact_feature.jpg'),
            company: "Wonderful Works",
            material: "PVC, ABS",
            tagName: ["Anime", "Game"],
            size: "24.7 cm",
            otherImages:
                [
                    {
                        id: 407,
                        imgUrl: require('./productImage/Genshin/Astral Reflection Mona/astral-reflection-mona_genshin-impact_gallery_1.jpg'),
                    },
                    {
                        id: 408,
                        imgUrl: require('./productImage/Genshin/Astral Reflection Mona/astral-reflection-mona_genshin-impact_gallery_2.jpg'),
                    },
                    {
                        id: 409,
                        imgUrl: require('./productImage/Genshin/Astral Reflection Mona/astral-reflection-mona_genshin-impact_gallery_3.jpg'),
                    },
                    {
                        id: 410,
                        imgUrl: require('./productImage/Genshin/Astral Reflection Mona/astral-reflection-mona_genshin-impact_gallery_4.jpg'),
                    },
                    {
                        id: 411,
                        imgUrl: require('./productImage/Genshin/Astral Reflection Mona/astral-reflection-mona_genshin-impact_gallery_5.jpg'),
                    },
                    {
                        id: 412,
                        imgUrl: require('./productImage/Genshin/Astral Reflection Mona/astral-reflection-mona_genshin-impact_gallery_6.jpg'),
                    },
                ],

        }
    },
    {
        id: 79,
        name: "Barbara",
        tagName: ["Anime", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Genshin/Barbara/barbara_genshin-impact_silo_sm.png'),
        price: 650000,
        depositPrice: 320000,
        categoryID: 11,
        stock: 0,
        details:
        {
            description: "Từ game nhập vai thế giới mở Genshin Impact thế hệ tiếp theo, Kotobukiya tự hào giới thiệu Tượng Barbara đáng yêu!" +

                " Barbara, Nữ phó tế của Nhà thờ Favonius và thần tượng của Mondstadt, trở nên sống động trong một bức tượng tỷ lệ 1: 7 năng động. Vẻ quyến rũ không thể phủ nhận của cô đã được tái hiện đầy đủ và ấn tượng, hoàn chỉnh với biểu cảm đáng yêu và chiếc váy bồng bềnh. Cô ấy cũng đi kèm với các hiệu ứng ca hát đã được sản xuất với các bộ phận rõ ràng và có thể được loại bỏ để có nhiều tùy chọn hiển thị!"
            ,
            imageDescription: require('./productImage/Genshin/Barbara/barbara_genshin-impact_feature.jpg'),
            company: "Kotobukiya",
            material: "PVC, ABS, Sắt",
            tagName: ["Anime", "Game"],
            size: "27 cm",
            otherImages:
                [
                    {
                        id: 413,
                        imgUrl: require('./productImage/Genshin/Barbara/barbara_genshin-impact_gallery_1.jpg'),
                    },
                    {
                        id: 414,
                        imgUrl: require('./productImage/Genshin/Barbara/barbara_genshin-impact_gallery_2.jpg'),
                    },
                    {
                        id: 415,
                        imgUrl: require('./productImage/Genshin/Barbara/barbara_genshin-impact_gallery_3.jpg'),
                    },
                    {
                        id: 416,
                        imgUrl: require('./productImage/Genshin/Barbara/barbara_genshin-impact_gallery_4.jpg'),
                    },
                    {
                        id: 417,
                        imgUrl: require('./productImage/Genshin/Barbara/barbara_genshin-impact_gallery_5.jpg'),
                    },
                    {
                        id: 418,
                        imgUrl: require('./productImage/Genshin/Barbara/barbara_genshin-impact_gallery_6.jpg'),
                    },
                    {
                        id: 419,
                        imgUrl: require('./productImage/Genshin/Barbara/barbara_genshin-impact_gallery_7.jpg'),
                    },
                ],

        }
    },
    {
        id: 80,
        name: "Ganyu Frostdew Trail Version",
        tagName: ["Anime", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__silo_sm.png'),
        price: 755260,
        depositPrice: 352000,
        categoryID: 11,
        stock: 0,
        details:
        {
            description: "Ganyu từ Genshin Impact với dáng pose không thể nào tuyệt vời hơn. Còn chần chờ gì nữa mà không mua ngay!"
            ,
            imageDescription: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__feature.jpg'),
            company: "APEX",
            material: "PVC, ABS",
            tagName: ["Anime", "Game"],
            size: "22 cm",
            otherImages:
                [
                    {
                        id: 420,
                        imgUrl: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__gallery_1.jpg'),
                    },
                    {
                        id: 421,
                        imgUrl: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__gallery_2.jpg'),
                    },
                    {
                        id: 422,
                        imgUrl: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__gallery_3.jpg'),
                    },
                    {
                        id: 423,
                        imgUrl: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__gallery_4.jpg'),
                    },
                    {
                        id: 424,
                        imgUrl: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__gallery_5.jpg'),
                    },
                    {
                        id: 425,
                        imgUrl: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__gallery_6.jpg'),
                    },
                    {
                        id: 426,
                        imgUrl: require('./productImage/Genshin/Ganyu Frostdew Trail Version/ganyu-frostdew-trail-version__gallery_7.jpg'),
                    },
                ],

        }
    },
    {
        id: 81,
        name: "Keqing Piercing Thunderbolt Version",
        tagName: ["Anime", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Genshin/Keqing Piercing Thunderbolt Version/keqing-piercing-thunderbolt-version_genshin-impact_silo_sm.png'),
        price: 755260,
        depositPrice: 352000,
        categoryID: 11,
        stock: 0,
        details:
        {
            description: "Keqing từ Genshin Impact với dáng pose không thể nào tuyệt vời hơn. Còn chần chờ gì nữa mà không mua ngay!"
            ,
            imageDescription: require('./productImage/Genshin/Keqing Piercing Thunderbolt Version/keqing-piercing-thunderbolt-version_genshin-impact_feature.jpg'),
            company: "APEX",
            material: "PVC, ABS",
            tagName: ["Anime", "Game"],
            size: "22 cm",
            otherImages:
                [
                    {
                        id: 427,
                        imgUrl: require('./productImage/Genshin/Keqing Piercing Thunderbolt Version/keqing-piercing-thunderbolt-version_genshin-impact_gallery_1.jpg'),
                    },
                    {
                        id: 428,
                        imgUrl: require('./productImage/Genshin/Keqing Piercing Thunderbolt Version/keqing-piercing-thunderbolt-version_genshin-impact_gallery_2.jpg'),
                    },
                    {
                        id: 429,
                        imgUrl: require('./productImage/Genshin/Keqing Piercing Thunderbolt Version/keqing-piercing-thunderbolt-version_genshin-impact_gallery_3.jpg'),
                    },
                    {
                        id: 430,
                        imgUrl: require('./productImage/Genshin/Keqing Piercing Thunderbolt Version/keqing-piercing-thunderbolt-version_genshin-impact_gallery_4.jpg'),
                    },
                    {
                        id: 431,
                        imgUrl: require('./productImage/Genshin/Keqing Piercing Thunderbolt Version/keqing-piercing-thunderbolt-version_genshin-impact_gallery_5.jpg'),
                    },
                    {
                        id: 432,
                        imgUrl: require('./productImage/Genshin/Keqing Piercing Thunderbolt Version/keqing-piercing-thunderbolt-version_genshin-impact_gallery_6.jpg'),
                    },
                ],

        }
    },
    {
        id: 82,
        name: "Klee the Spark Knight",
        tagName: ["Anime", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Genshin/Klee the Spark Knight/klee-the-spark-knight_genshin-impact_silo_sm.png'),
        price: 652000,
        depositPrice: 320000,
        categoryID: 11,
        stock: 0,
        details:
        {
            description: "Từ trò chơi nhập vai hành động ăn khách do miHoYo phát triển và xuất bản, Genshin Impact, đến nhân vật cô gái mặc đồ đỏ đáng yêu Klee đang ngồi trên người bạn của mình, Jumpy Dumpy, sẵn sàng cho một cuộc phiêu lưu." +

                " Đừng bỏ lỡ cơ hội bổ sung em ấy vào bộ sưu tập của bạn!"
            ,
            imageDescription: require('./productImage/Genshin/Klee the Spark Knight/klee-the-spark-knight_genshin-impact_feature.jpg'),
            company: "miHoYo",
            material: "PVC, ABS",
            tagName: ["Anime", "Game"],
            size: "17.5 cm",
            otherImages:
                [
                    {
                        id: 433,
                        imgUrl: require('./productImage/Genshin/Klee the Spark Knight/klee-the-spark-knight_genshin-impact_gallery_1.jpg'),
                    },
                    {
                        id: 434,
                        imgUrl: require('./productImage/Genshin/Klee the Spark Knight/klee-the-spark-knight_genshin-impact_gallery_2.jpg'),
                    },
                    {
                        id: 435,
                        imgUrl: require('./productImage/Genshin/Klee the Spark Knight/klee-the-spark-knight_genshin-impact_gallery_3.jpg'),
                    },
                    {
                        id: 436,
                        imgUrl: require('./productImage/Genshin/Klee the Spark Knight/klee-the-spark-knight_genshin-impact_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 83,
        name: "Mona Figma (Mirror Reflection of Doom Ver.)",
        tagName: ["Anime", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Genshin/Mona Figma (Mirror Reflection of Doom Ver.)/mona-figma-mirror-reflection-of-doom-ver_genshin-impact_silo_sm.png'),
        price: 350250,
        depositPrice: 150000,
        categoryID: 11,
        stock: 0,
        details:
        {
            description: "Với các phụ kiện đi kèm và các khớp nối trơn tru nhưng có thể điều chỉnh được đặc trưng của loạt nhân vật hành động Figma, bạn có thể tạo lại nhiều tư thế hành động đa dạng từ trò chơi điện tử nổi tiếng"
            ,
            imageDescription: require('./productImage/Genshin/Mona Figma (Mirror Reflection of Doom Ver.)/mona-figma-mirror-reflection-of-doom-ver_genshin-impact_feature.jpg'),
            company: "Max Factory",
            material: "PVC, ABS, PET",
            tagName: ["Anime", "Game"],
            size: "15 cm",
            otherImages:
                [
                    {
                        id: 437,
                        imgUrl: require('./productImage/Genshin/Mona Figma (Mirror Reflection of Doom Ver.)/mona-figma-mirror-reflection-of-doom-ver_genshin-impact_gallery_1.jpg'),
                    },
                    {
                        id: 438,
                        imgUrl: require('./productImage/Genshin/Mona Figma (Mirror Reflection of Doom Ver.)/mona-figma-mirror-reflection-of-doom-ver_genshin-impact_gallery_2.jpg'),
                    },
                    {
                        id: 439,
                        imgUrl: require('./productImage/Genshin/Mona Figma (Mirror Reflection of Doom Ver.)/mona-figma-mirror-reflection-of-doom-ver_genshin-impact_gallery_3.jpg'),
                    },
                    {
                        id: 440,
                        imgUrl: require('./productImage/Genshin/Mona Figma (Mirror Reflection of Doom Ver.)/mona-figma-mirror-reflection-of-doom-ver_genshin-impact_gallery_4.jpg'),
                    },
                    {
                        id: 441,
                        imgUrl: require('./productImage/Genshin/Mona Figma (Mirror Reflection of Doom Ver.)/mona-figma-mirror-reflection-of-doom-ver_genshin-impact_gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 84,
        name: "Ningguang",
        tagName: ["Anime", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_silo_sm.png'),
        price: 1265000,
        depositPrice: 450000,
        categoryID: 11,
        stock: 0,
        details:
        {
            description: "Mô hình sưu tập này cao hơn 27cm và Ninggquang, doanh nhân chuyên nghiệp rất giàu có đang ngồi trên một chiếc ghế giống như gỗ, khoe những hình xăm màu đỏ và mái tóc dài trắng búi nửa đầu nổi tiếng. Bộ sưu tập này cũng bao gồm nền và phụ kiện lấy cảm hứng từ Nhật Bản cho thiết lập hoàn hảo"
            ,
            imageDescription: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_feature.jpg'),
            company: "miHoYo",
            material: "PVC",
            tagName: ["Anime", "Game"],
            size: "27 cm",
            otherImages:
                [
                    {
                        id: 442,
                        imgUrl: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_gallery_1.jpg'),
                    },
                    {
                        id: 443,
                        imgUrl: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_gallery_2.jpg'),
                    },
                    {
                        id: 444,
                        imgUrl: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_gallery_3.jpg'),
                    },
                    {
                        id: 445,
                        imgUrl: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_gallery_4.jpg'),
                    },
                    {
                        id: 446,
                        imgUrl: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_gallery_5.jpg'),
                    },
                    {
                        id: 447,
                        imgUrl: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_gallery_6.jpg'),
                    },
                    {
                        id: 448,
                        imgUrl: require('./productImage/Genshin/Ningguang/ningguang_genshin-impact_gallery_7.jpg'),
                    },
                ],

        }
    },
    {
        id: 85,
        name: "Venti Nendoroid",
        tagName: ["Anime", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Genshin/Venti Nendoroid/venti-nendoroid_genshin-impact_silo_sm.png'),
        price: 350000,
        depositPrice: 150000,
        categoryID: 11,
        stock: 0,
        details:
        {
            description: "Từ trò chơi nổi tiếng, Genshin Impact là Nendoroid của Windborne Bard, Venti! " +

                "Anh ấy có ba biểu cảm khuôn mặt bao gồm khuôn mặt nháy mắt, khuôn mặt thoải mái với đôi mắt nhắm và một khuôn mặt đang cười. Các phần tùy chọn bao gồm đàn lia bằng gỗ của anh ấy, Der Frühling, cũng như cây cung Skyward Harp, cho phép bạn tạo lại các cảnh chiến đấu từ trò chơi."
            ,
            imageDescription: require('./productImage/Genshin/Venti Nendoroid/venti-nendoroid_genshin-impact_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC",
            tagName: ["Anime", "Game"],
            size: "10 cm",
            otherImages:
                [
                    {
                        id: 449,
                        imgUrl: require('./productImage/Genshin/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_1.jpg'),
                    },
                    {
                        id: 450,
                        imgUrl: require('./productImage/Genshin/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_2.jpg'),
                    },
                    {
                        id: 451,
                        imgUrl: require('./productImage/Genshin/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_3.jpg'),
                    },
                    {
                        id: 452,
                        imgUrl: require('./productImage/Genshin/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_4.jpg'),
                    },
                    {
                        id: 453,
                        imgUrl: require('./productImage/Genshin/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_5.jpg'),
                    },
                ],

        }
    },

    //Nendoroid
    {
        id: 86,
        name: "Giyu Tomioka Nendoroid",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Giyu Tomioka Nendoroid/giyu-tomioka-nendoroid_demon-slayer_silo_sm.png'),
        price: 355000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Giyu Tomioka từ Demon Slayer: Kimetsu no Yaiba sẽ tham gia Nendoroid Swacchao mới! hàng loạt!" +
                " Nendoroid Swacchao! figure có Nendoroid đang ngồi trên ghế, giúp bạn dễ dàng trưng bày chúng trên bàn, kệ hoặc những khu vực chật hẹp về không gian. Các số liệu thậm chí có thể được hiển thị trên các cạnh của bàn hoặc kệ của bạn, vì vậy hãy tận hưởng thu thập và trưng bày chúng ở mọi nơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Giyu Tomioka Nendoroid/giyu-tomioka-nendoroid_demon-slayer_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC",
            tagName: ["Anime", "Nendoroid"],
            size: "9 cm",
            otherImages:
                [
                    {
                        id: 454,
                        imgUrl: require('./productImage/Nendoroid/Giyu Tomioka Nendoroid/giyu-tomioka-nendoroid_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 455,
                        imgUrl: require('./productImage/Nendoroid/Giyu Tomioka Nendoroid/giyu-tomioka-nendoroid_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 456,
                        imgUrl: require('./productImage/Nendoroid/Giyu Tomioka Nendoroid/giyu-tomioka-nendoroid_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 457,
                        imgUrl: require('./productImage/Nendoroid/Giyu Tomioka Nendoroid/giyu-tomioka-nendoroid_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 87,
        name: "Kakashi Hatake: Anbu Black Ops Version Nendoroid",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Kakashi Hatake Anbu Black Ops Version Nendoroid/kakashi-hatake-anbu-black-ops-version-nendoroid_naruto-shippuden_silo_sm.png'),
        price: 425000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Từ loạt phim hoạt hình nổi tiếng Naruto Shippuden, Nendoroid của Kakashi Hatake từ thời của anh ấy trong Anbu Black Ops! Anh ấy đi kèm với hai tấm che mặt có thể hoán đổi cho nhau, một tấm che mặt tiêu chuẩn và một tấm che mặt lóa. Mặt nạ cáo của anh ấy cũng có thể tháo rời."
            ,
            imageDescription: require('./productImage/Nendoroid/Kakashi Hatake Anbu Black Ops Version Nendoroid/kakashi-hatake-anbu-black-ops-version-nendoroid_naruto-shippuden_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC",
            tagName: ["Anime", "Nendoroid"],
            size: "10 cm",
            otherImages:
                [
                    {
                        id: 458,
                        imgUrl: require('./productImage/Nendoroid/Kakashi Hatake Anbu Black Ops Version Nendoroid/kakashi-hatake-anbu-black-ops-version-nendoroid_naruto-shippuden_gallery_1.jpg'),
                    },
                    {
                        id: 459,
                        imgUrl: require('./productImage/Nendoroid/Kakashi Hatake Anbu Black Ops Version Nendoroid/kakashi-hatake-anbu-black-ops-version-nendoroid_naruto-shippuden_gallery_2.jpg'),
                    },
                    {
                        id: 460,
                        imgUrl: require('./productImage/Nendoroid/Kakashi Hatake Anbu Black Ops Version Nendoroid/kakashi-hatake-anbu-black-ops-version-nendoroid_naruto-shippuden_gallery_3.jpg'),
                    },
                    {
                        id: 461,
                        imgUrl: require('./productImage/Nendoroid/Kakashi Hatake Anbu Black Ops Version Nendoroid/kakashi-hatake-anbu-black-ops-version-nendoroid_naruto-shippuden_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 88,
        name: "Katsuki Bakugo Nendoroid",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Katsuki Bakugo Nendoroid/katsuki-bakugo-nendoroid_my-hero-academia_silo_sm.png'),
        price: 520000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Từ loạt phim hoạt hình nổi tiếng My Hero Academia, Nendoroid của nhân vật chính là bạn thời thơ ấu của Deku và là đối thủ của Katsuki Bakugo trong trang phục mùa đông của anh ấy! Anh ấy có ba biểu cảm khuôn mặt bao gồm biểu cảm cười toe toét, biểu cảm chiến đấu và biểu cảm sửng sốt! Các bộ phận hiệu ứng để tái hiện Cú cười bùng nổ của anh ấy cùng với bảng chữ BOOOM cũng được bao gồm để tạo ra các tư thế hành động ấn tượng hơn nữa! Thích tạo tất cả các loại cảnh khác nhau từ bộ truyện!"
            ,
            imageDescription: require('./productImage/Nendoroid/Katsuki Bakugo Nendoroid/katsuki-bakugo-nendoroid_my-hero-academia_feature.jpg'),
            company: "Takara Tomy",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "10 cm",
            otherImages:
                [
                    {
                        id: 462,
                        imgUrl: require('./productImage/Nendoroid/Katsuki Bakugo Nendoroid/katsuki-bakugo-nendoroid_my-hero-academia_gallery_1.jpg'),
                    },
                    {
                        id: 463,
                        imgUrl: require('./productImage/Nendoroid/Katsuki Bakugo Nendoroid/katsuki-bakugo-nendoroid_my-hero-academia_gallery_2.jpg'),
                    },
                    {
                        id: 464,
                        imgUrl: require('./productImage/Nendoroid/Katsuki Bakugo Nendoroid/katsuki-bakugo-nendoroid_my-hero-academia_gallery_3.jpg'),
                    },
                    {
                        id: 465,
                        imgUrl: require('./productImage/Nendoroid/Katsuki Bakugo Nendoroid/katsuki-bakugo-nendoroid_my-hero-academia_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 89,
        name: "Kyojuro Rengoku Nendoroid",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Kyojuro Rengoku Nendoroid/kyojuro-rengoku-nendoroid_demon-slayer_silo_sm.png'),
        price: 325000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Kyojuro Rengoku từ Demon Slayer: Kimetsu no Yaiba sẽ gia nhập Nendoroid Swacchao mới! hàng loạt!" +
                " Nendoroid Swacchao! figure có Nendoroid đang ngồi trên ghế, giúp bạn dễ dàng trưng bày chúng trên bàn, kệ hoặc những khu vực chật hẹp về không gian. Các số liệu thậm chí có thể được hiển thị trên các cạnh của bàn hoặc kệ của bạn, vì vậy hãy tận hưởng thu thập và trưng bày chúng ở mọi nơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Kyojuro Rengoku Nendoroid/kyojuro-rengoku-nendoroid_demon-slayer_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "9 cm",
            otherImages:
                [
                    {
                        id: 466,
                        imgUrl: require('./productImage/Nendoroid/Kyojuro Rengoku Nendoroid/kyojuro-rengoku-nendoroid_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 467,
                        imgUrl: require('./productImage/Nendoroid/Kyojuro Rengoku Nendoroid/kyojuro-rengoku-nendoroid_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 468,
                        imgUrl: require('./productImage/Nendoroid/Kyojuro Rengoku Nendoroid/kyojuro-rengoku-nendoroid_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 469,
                        imgUrl: require('./productImage/Nendoroid/Kyojuro Rengoku Nendoroid/kyojuro-rengoku-nendoroid_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 90,
        name: "Megumi Fushiguro Nendoroid Swacchao!",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Megumi Fushiguro Nendoroid Swacchao/megumi-fushiguro-nendoroid-swacchao_jujutsu-kaisen_silo_sm.png'),
        price: 325000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Megumi Fushiguro từ Jujutsi Kaisen sẽ gia nhập Nendoroid Swacchao mới! hàng loạt!" +
                " Nendoroid Swacchao! figure có Nendoroid đang ngồi trên ghế, giúp bạn dễ dàng trưng bày chúng trên bàn, kệ hoặc những khu vực chật hẹp về không gian. Các số liệu thậm chí có thể được hiển thị trên các cạnh của bàn hoặc kệ của bạn, vì vậy hãy tận hưởng thu thập và trưng bày chúng ở mọi nơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Megumi Fushiguro Nendoroid Swacchao/megumi-fushiguro-nendoroid-swacchao_jujutsu-kaisen_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "9 cm",
            otherImages:
                [
                    {
                        id: 470,
                        imgUrl: require('./productImage/Nendoroid/Megumi Fushiguro Nendoroid Swacchao/megumi-fushiguro-nendoroid-swacchao_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 471,
                        imgUrl: require('./productImage/Nendoroid/Megumi Fushiguro Nendoroid Swacchao/megumi-fushiguro-nendoroid-swacchao_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 472,
                        imgUrl: require('./productImage/Nendoroid/Megumi Fushiguro Nendoroid Swacchao/megumi-fushiguro-nendoroid-swacchao_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 473,
                        imgUrl: require('./productImage/Nendoroid/Megumi Fushiguro Nendoroid Swacchao/megumi-fushiguro-nendoroid-swacchao_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 91,
        name: "Nobara Kugisaki Nendoroid Swacchao!",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Nobara Kugisaki Nendoroid Swacchao/nobara-kugisaki-nendoroid-swacchao_jujutsu-kaisen_silo_sm.png'),
        price: 325000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Nobara Kugisaki từ Jujutsi Kaisen sẽ gia nhập Nendoroid Swacchao mới! hàng loạt!" +
                " Nendoroid Swacchao! figure có Nendoroid đang ngồi trên ghế, giúp bạn dễ dàng trưng bày chúng trên bàn, kệ hoặc những khu vực chật hẹp về không gian. Các số liệu thậm chí có thể được hiển thị trên các cạnh của bàn hoặc kệ của bạn, vì vậy hãy tận hưởng thu thập và trưng bày chúng ở mọi nơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Nobara Kugisaki Nendoroid Swacchao/nobara-kugisaki-nendoroid-swacchao_jujutsu-kaisen_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "9 cm",
            otherImages:
                [
                    {
                        id: 474,
                        imgUrl: require('./productImage/Nendoroid/Nobara Kugisaki Nendoroid Swacchao/nobara-kugisaki-nendoroid-swacchao_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 475,
                        imgUrl: require('./productImage/Nendoroid/Nobara Kugisaki Nendoroid Swacchao/nobara-kugisaki-nendoroid-swacchao_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 476,
                        imgUrl: require('./productImage/Nendoroid/Nobara Kugisaki Nendoroid Swacchao/nobara-kugisaki-nendoroid-swacchao_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 477,
                        imgUrl: require('./productImage/Nendoroid/Nobara Kugisaki Nendoroid Swacchao/nobara-kugisaki-nendoroid-swacchao_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 92,
        name: "Satoru Gojo Nendoroid Swacchao!",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Satoru Gojo Nendoroid Swacchao/satoru-gojo-nendoroid-swacchao_jujutsu-kaisen_silo_sm.png'),
        price: 325000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Satoru Gojo từ Jujutsi Kaisen sẽ gia nhập Nendoroid Swacchao mới! hàng loạt!" +
                " Nendoroid Swacchao! figure có Nendoroid đang ngồi trên ghế, giúp bạn dễ dàng trưng bày chúng trên bàn, kệ hoặc những khu vực chật hẹp về không gian. Các số liệu thậm chí có thể được hiển thị trên các cạnh của bàn hoặc kệ của bạn, vì vậy hãy tận hưởng thu thập và trưng bày chúng ở mọi nơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Satoru Gojo Nendoroid Swacchao/satoru-gojo-nendoroid-swacchao_jujutsu-kaisen_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "9 cm",
            otherImages:
                [
                    {
                        id: 478,
                        imgUrl: require('./productImage/Nendoroid/Satoru Gojo Nendoroid Swacchao/satoru-gojo-nendoroid-swacchao_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 479,
                        imgUrl: require('./productImage/Nendoroid/Satoru Gojo Nendoroid Swacchao/satoru-gojo-nendoroid-swacchao_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 480,
                        imgUrl: require('./productImage/Nendoroid/Satoru Gojo Nendoroid Swacchao/satoru-gojo-nendoroid-swacchao_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 481,
                        imgUrl: require('./productImage/Nendoroid/Satoru Gojo Nendoroid Swacchao/satoru-gojo-nendoroid-swacchao_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 93,
        name: "Shinobu Kocho Nendoroid",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Shinobu Kocho Nendoroid/shinobu-kocho-nendoroid_demon-slayer_silo_sm.png'),
        price: 350000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Shinobu Kocho từ Demon Slayer: Kimetsu no Yaiba sẽ gia nhập Nendoroid Swacchao mới! hàng loạt!" +
                " Nendoroid Swacchao! figure có Nendoroid đang ngồi trên ghế, giúp bạn dễ dàng trưng bày chúng trên bàn, kệ hoặc những khu vực chật hẹp về không gian. Các số liệu thậm chí có thể được hiển thị trên các cạnh của bàn hoặc kệ của bạn, vì vậy hãy tận hưởng thu thập và trưng bày chúng ở mọi nơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Shinobu Kocho Nendoroid/shinobu-kocho-nendoroid_demon-slayer_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "9 cm",
            otherImages:
                [
                    {
                        id: 482,
                        imgUrl: require('./productImage/Nendoroid/Shinobu Kocho Nendoroid/shinobu-kocho-nendoroid_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 483,
                        imgUrl: require('./productImage/Nendoroid/Shinobu Kocho Nendoroid/shinobu-kocho-nendoroid_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 484,
                        imgUrl: require('./productImage/Nendoroid/Shinobu Kocho Nendoroid/shinobu-kocho-nendoroid_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 485,
                        imgUrl: require('./productImage/Nendoroid/Shinobu Kocho Nendoroid/shinobu-kocho-nendoroid_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 94,
        name: "Sukuna Nendoroid",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Sukuna Nendoroid/sukuna-nendoroid__silo_sm.png'),
        price: 350000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Sukuna từ Jujutsu Kaisen sẽ gia nhập Nendoroid Swacchao mới! hàng loạt!" +
                " Nendoroid Swacchao! figure có Nendoroid đang ngồi trên ghế, giúp bạn dễ dàng trưng bày chúng trên bàn, kệ hoặc những khu vực chật hẹp về không gian. Các số liệu thậm chí có thể được hiển thị trên các cạnh của bàn hoặc kệ của bạn, vì vậy hãy tận hưởng thu thập và trưng bày chúng ở mọi nơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Sukuna Nendoroid/sukuna-nendoroid__feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "10 cm",
            otherImages:
                [
                    {
                        id: 486,
                        imgUrl: require('./productImage/Nendoroid/Sukuna Nendoroid/sukuna-nendoroid__gallery_1.jpg'),
                    },
                    {
                        id: 487,
                        imgUrl: require('./productImage/Nendoroid/Sukuna Nendoroid/sukuna-nendoroid__gallery_2.jpg'),
                    },
                    {
                        id: 488,
                        imgUrl: require('./productImage/Nendoroid/Sukuna Nendoroid/sukuna-nendoroid__gallery_3.jpg'),
                    },
                    {
                        id: 489,
                        imgUrl: require('./productImage/Nendoroid/Sukuna Nendoroid/sukuna-nendoroid__gallery_4.jpg'),
                    },
                    {
                        id: 490,
                        imgUrl: require('./productImage/Nendoroid/Sukuna Nendoroid/sukuna-nendoroid__gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 95,
        name: "Venti Nendoroid",
        tagName: ["Anime", "Nendoroid", "Game"],
        status: "preOrder",
        thumbImg: require('./productImage/Nendoroid/Venti Nendoroid/venti-nendoroid_genshin-impact_silo_sm.png'),
        price: 350000,
        depositPrice: 150000,
        categoryID: 10,
        stock: 0,
        details:
        {
            description: "Từ trò chơi nổi tiếng, Genshin Impact là Nendoroid của Windborne Bard, Venti! " +

                "Anh ấy có ba biểu cảm khuôn mặt bao gồm khuôn mặt nháy mắt, khuôn mặt thoải mái với đôi mắt nhắm và một khuôn mặt đang cười. Các phần tùy chọn bao gồm đàn lia bằng gỗ của anh ấy, Der Frühling, cũng như cây cung Skyward Harp, cho phép bạn tạo lại các cảnh chiến đấu từ trò chơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Venti Nendoroid/venti-nendoroid_genshin-impact_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid", "Game"],
            size: "10 cm",
            otherImages:
                [
                    {
                        id: 491,
                        imgUrl: require('./productImage/Nendoroid/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_1.jpg'),
                    },
                    {
                        id: 492,
                        imgUrl: require('./productImage/Nendoroid/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_2.jpg'),
                    },
                    {
                        id: 493,
                        imgUrl: require('./productImage/Nendoroid/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_3.jpg'),
                    },
                    {
                        id: 494,
                        imgUrl: require('./productImage/Nendoroid/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_4.jpg'),
                    },
                    {
                        id: 495,
                        imgUrl: require('./productImage/Nendoroid/Venti Nendoroid/venti-nendoroid_genshin-impact_gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 96,
        name: "Yuji Itadori Nendoroid Swacchao!",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Yuji Itadori Nendoroid Swacchao/yuji-itadori-nendoroid-swacchao_jujutsu-kaisen_silo_sm.png'),
        price: 350000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Yuji Itadori từ Jujutsu Kaisen sẽ gia nhập Nendoroid Swacchao mới! hàng loạt!" +
                " Nendoroid Swacchao! figure có Nendoroid đang ngồi trên ghế, giúp bạn dễ dàng trưng bày chúng trên bàn, kệ hoặc những khu vực chật hẹp về không gian. Các số liệu thậm chí có thể được hiển thị trên các cạnh của bàn hoặc kệ của bạn, vì vậy hãy tận hưởng thu thập và trưng bày chúng ở mọi nơi."
            ,
            imageDescription: require('./productImage/Nendoroid/Yuji Itadori Nendoroid Swacchao/yuji-itadori-nendoroid-swacchao_jujutsu-kaisen_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "10 cm",
            otherImages:
                [
                    {
                        id: 496,
                        imgUrl: require('./productImage/Nendoroid/Yuji Itadori Nendoroid Swacchao/yuji-itadori-nendoroid-swacchao_jujutsu-kaisen_gallery_1.jpg'),
                    },
                    {
                        id: 497,
                        imgUrl: require('./productImage/Nendoroid/Yuji Itadori Nendoroid Swacchao/yuji-itadori-nendoroid-swacchao_jujutsu-kaisen_gallery_2.jpg'),
                    },
                    {
                        id: 498,
                        imgUrl: require('./productImage/Nendoroid/Yuji Itadori Nendoroid Swacchao/yuji-itadori-nendoroid-swacchao_jujutsu-kaisen_gallery_3.jpg'),
                    },
                    {
                        id: 499,
                        imgUrl: require('./productImage/Nendoroid/Yuji Itadori Nendoroid Swacchao/yuji-itadori-nendoroid-swacchao_jujutsu-kaisen_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 97,
        name: "Zenitsu Agatsuma Nendoroid",
        tagName: ["Anime", "Nendoroid"],
        status: "available",
        thumbImg: require('./productImage/Nendoroid/Zenitsu Agatsuma Nendoroid/zenitsu-agatsuma-nendoroid_demon-slayer_silo_sm.png'),
        price: 350000,
        categoryID: 10,
        stock: 10,
        details:
        {
            description: "Từ loạt phim hoạt hình Demon Slayer: Kimetsu no Yaiba, Nendoroid đã thành thạo Hơi thở Sấm sét, Zenitsu Agatsuma!" +
                " Anh ấy có 4 biểu cảm khuôn mặt bao gồm biểu cảm chuẩn, biểu cảm đang ngủ, biểu cảm đỏ mặt và biểu cảm giật mình. Các phần tùy chọn bao gồm một nhân vật thu nhỏ của Chuntaro và Nichirin Blade của anh ta, cùng với các bộ phận chân cong có thể hoán đổi cho nhau và các bộ phận hiệu ứng để tái tạo những khoảnh khắc ngay lập tức trước và sau khi tung ra đòn tấn công Nhanh như chớp của Thunder Breathing First Form: Thunderclap và Flash."
            ,
            imageDescription: require('./productImage/Nendoroid/Zenitsu Agatsuma Nendoroid/zenitsu-agatsuma-nendoroid_demon-slayer_feature.jpg'),
            company: "Good Smile Company",
            material: "PVC, ABS",
            tagName: ["Anime", "Nendoroid"],
            size: "10 cm",
            otherImages:
                [
                    {
                        id: 500,
                        imgUrl: require('./productImage/Nendoroid/Zenitsu Agatsuma Nendoroid/zenitsu-agatsuma-nendoroid_demon-slayer_gallery_1.jpg'),
                    },
                    {
                        id: 501,
                        imgUrl: require('./productImage/Nendoroid/Zenitsu Agatsuma Nendoroid/zenitsu-agatsuma-nendoroid_demon-slayer_gallery_2.jpg'),
                    },
                    {
                        id: 502,
                        imgUrl: require('./productImage/Nendoroid/Zenitsu Agatsuma Nendoroid/zenitsu-agatsuma-nendoroid_demon-slayer_gallery_3.jpg'),
                    },
                    {
                        id: 503,
                        imgUrl: require('./productImage/Nendoroid/Zenitsu Agatsuma Nendoroid/zenitsu-agatsuma-nendoroid_demon-slayer_gallery_4.jpg'),
                    },
                ],

        }
    },

    //Transformer
    {
        id: 98,
        name: "Bumblebee DLX",
        tagName: ["Hành Động", "Robot"],
        status: "new",
        thumbImg: require('./productImage/Transformer/Bumblebee DLX/bumblebee-dlx_transformers_silo_sm.png'),
        price: 455000,
        categoryID: 1,
        stock: 10,
        details:
        {
            description: "DLX Sưu tầm Hình thể hiện các thiết kế hình Transformers phức tạp ở quy mô nhỏ hơn với giá trị sản xuất có độ trung thực cao. Với thiết kế khung kim loại đúc độc đáo, DLX không chỉ cung cấp một loạt các khớp nối tiên tiến mà còn nâng cao đáng kể trọng lượng và độ bền"
            ,
            imageDescription: require('./productImage/Transformer/Bumblebee DLX/bumblebee-dlx_transformers_feature.jpg'),
            company: "Threezero",
            material: "ABS, PC, POM, PVC, Diecast zinc alloy",
            tagName: ["Hành Động", "Robot"],
            size: "21.6 cm",
            otherImages:
                [
                    {
                        id: 504,
                        imgUrl: require('./productImage/Transformer/Bumblebee DLX/bumblebee-dlx_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 505,
                        imgUrl: require('./productImage/Transformer/Bumblebee DLX/bumblebee-dlx_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 506,
                        imgUrl: require('./productImage/Transformer/Bumblebee DLX/bumblebee-dlx_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 507,
                        imgUrl: require('./productImage/Transformer/Bumblebee DLX/bumblebee-dlx_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 99,
        name: "Bumblebee",
        tagName: ["Hành Động", "Robot"],
        status: "available",
        thumbImg: require('./productImage/Transformer/Bumblebee movie/bumblebee_transformers_silo_sm.png'),
        price: 455000,
        categoryID: 1,
        stock: 10,
        details:
        {
            description: "Con số DLX Scale Collectible này có tác phẩm điêu khắc chi tiết phức tạp, một loạt các khớp nối cao, các chi tiết được chiếu sáng bằng đèn LED, các bộ phận kim loại đúc và lớp sơn chuyên nghiệp mà 3A & 3Zero nổi tiếng."
            ,
            imageDescription: require('./productImage/Transformer/Bumblebee movie/bumblebee_transformers_feature.jpg'),
            company: "Threezero",
            material: "ABS",
            tagName: ["Hành Động", "Robot"],
            size: "20.3 cm",
            otherImages:
                [
                    {
                        id: 508,
                        imgUrl: require('./productImage/Transformer/Bumblebee movie/bumblebee_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 509,
                        imgUrl: require('./productImage/Transformer/Bumblebee movie/bumblebee_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 510,
                        imgUrl: require('./productImage/Transformer/Bumblebee movie/bumblebee_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 511,
                        imgUrl: require('./productImage/Transformer/Bumblebee movie/bumblebee_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 100,
        name: "Bumblebee Nendoroid",
        tagName: ["Hành Động", "Robot"],
        status: "available",
        thumbImg: require('./productImage/Transformer/Bumblebee Nendoroid/bumblebee-nendoroid_transformers_silo_sm.png'),
        price: 405000,
        categoryID: 1,
        stock: 10,
        details:
        {
            description: "Từ bộ phim mới nhất trong loạt phim Người vận chuyển người thật, Bumblebee, là Nendoroid Bumblebee! Nendoroid được hoàn thiện đầy đủ các khớp nối, cho phép bạn tạo lại tất cả các loại tình huống, từ các tình huống hàng ngày đến các cảnh chiến đấu"
            ,
            imageDescription: require('./productImage/Transformer/Bumblebee Nendoroid/bumblebee-nendoroid_transformers_feature.jpg'),
            company: "Sentinel",
            material: "ABS, PVC",
            tagName: ["Hành Động", "Robot"],
            size: "9.9 cm",
            otherImages:
                [
                    {
                        id: 508,
                        imgUrl: require('./productImage/Transformer/Bumblebee Nendoroid/bumblebee-nendoroid_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 509,
                        imgUrl: require('./productImage/Transformer/Bumblebee Nendoroid/bumblebee-nendoroid_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 510,
                        imgUrl: require('./productImage/Transformer/Bumblebee Nendoroid/bumblebee-nendoroid_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 511,
                        imgUrl: require('./productImage/Transformer/Bumblebee Nendoroid/bumblebee-nendoroid_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 101,
        name: "Bumblebee",
        tagName: ["Hành Động", "Robot"],
        status: "preOrder",
        thumbImg: require('./productImage/Transformer/Bumblebee stand/bumblebee_transformers_silo_sm (2).png'),
        price: 758000,
        depositPrice: 250000,
        categoryID: 1,
        stock: 0,
        details:
        {
            description: "Tượng Bumblebee dựa trên bộ phim đi kèm với 2 bức chân dung thay thế. Chọn cách hiển thị Bumblebee của bạn giữa Chân dung mặt nạ chiến đấu hoặc Chân dung không mặt nạ hiển thị khuôn mặt dễ thương nhất trong số các Autobot!" +
                " Bumblebee này bao gồm hai tùy chọn Cánh tay phải có thể hoán đổi cho nhau. Mắt, đèn pha trước ngực và đèn pha có đèn LED trợ sáng. Vũ khí mạnh mẽ của anh ta, Bumblebee Stinger Sword chỉ có sẵn cho phiên bản độc quyền. Loại vũ khí nguy hiểm có thể khiến Decepticon chết. Sẵn sàng đưa vào màn hình của bạn với đế mang thương hiệu Autobots đặc biệt, đừng bỏ lỡ cơ hội thêm Bumblebee vào bộ sưu tập Transformers của bạn!"
            ,
            imageDescription: require('./productImage/Transformer/Bumblebee stand/bumblebee_transformers_feature.jpg'),
            company: "Prime 1 Studio",
            material: "Polystone",
            tagName: ["Hành Động", "Robot"],
            size: "67.4 cm",
            otherImages:
                [
                    {
                        id: 508,
                        imgUrl: require('./productImage/Transformer/Bumblebee stand/bumblebee_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 509,
                        imgUrl: require('./productImage/Transformer/Bumblebee stand/bumblebee_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 510,
                        imgUrl: require('./productImage/Transformer/Bumblebee stand/bumblebee_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 511,
                        imgUrl: require('./productImage/Transformer/Bumblebee stand/bumblebee_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 102,
        name: "Grimlock",
        tagName: ["Hành Động", "Robot"],
        status: "preOrder",
        thumbImg: require('./productImage/Transformer/Grimlock/grimlock_transformers_silo_sm.png'),
        price: 758000,
        depositPrice: 250000,
        categoryID: 1,
        stock: 0,
        details:
        {
            description: "Theo sau bức tượng cổ điển của chúng tôi được hiển thị lần đầu tiên vào năm 2014, cao khoảng 38 cm. Prime 1 Studio tự hào giới thiệu chiếc điện thoại cao 15 inch với tất cả vẻ đẹp lộng lẫy của nó: GRIMLOCK!" +
                " Grimlock chiếm vị trí trung tâm trong bộ phim Transformers năm 2014, Transformers: Age of Extinction. Anh hùng Dinobot đã đưa Optimus Prime đi kiểm tra, để xem liệu anh ta có thể chứng minh được mình là người lãnh đạo mà các Transformers xứng đáng hay không. Hợp tác với Optimus Prime và các Autobots khác, Grimlock đã lật ngược tình thế với Decepticons!"
            ,
            imageDescription: require('./productImage/Transformer/Grimlock/grimlock_transformers_feature.jpg'),
            company: "Prime 1 Studio",
            material: "Polystone",
            tagName: ["Hành Động", "Robot"],
            size: "38 cm",
            otherImages:
                [
                    {
                        id: 512,
                        imgUrl: require('./productImage/Transformer/Grimlock/grimlock_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 513,
                        imgUrl: require('./productImage/Transformer/Grimlock/grimlock_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 514,
                        imgUrl: require('./productImage/Transformer/Grimlock/grimlock_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 515,
                        imgUrl: require('./productImage/Transformer/Grimlock/grimlock_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 103,
        name: "Jetfire",
        tagName: ["Hành Động", "Robot"],
        status: "available",
        thumbImg: require('./productImage/Transformer/Jetfire/jetfire_transformers_silo_sm.png'),
        price: 450000,
        categoryID: 1,
        stock: 7,
        details:
        {
            description: "Decepticon Seeker cổ đại, người đã chọn sát cánh với Autobots và hy sinh tia lửa của mình cho Optimus Prime để hỗ trợ đánh bại The Fallen! Hasbro và Threezero tự hào giới thiệu Jetfire được mong đợi từ lâu từ Transformers: Revenge of the Fallen như là nhân vật tiếp theo trong Transformers DLX Collectible Figure Series!"
            ,
            imageDescription: require('./productImage/Transformer/Jetfire/jetfire_transformers_feature.jpg'),
            company: "Threezero",
            material: "ABS, POM, PVC, Diecast zinc alloy",
            tagName: ["Hành Động", "Robot"],
            size: "38 cm",
            otherImages:
                [
                    {
                        id: 516,
                        imgUrl: require('./productImage/Transformer/Jetfire/jetfire_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 517,
                        imgUrl: require('./productImage/Transformer/Jetfire/jetfire_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 518,
                        imgUrl: require('./productImage/Transformer/Jetfire/jetfire_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 519,
                        imgUrl: require('./productImage/Transformer/Jetfire/jetfire_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 104,
        name: "Megatron",
        tagName: ["Hành Động", "Robot"],
        status: "preOrder",
        thumbImg: require('./productImage/Transformer/Megatron/megatron_transformers_silo_sm.png'),
        price: 850000,
        depositPrice: 350000,
        categoryID: 1,
        stock: 0,
        details:
        {
            description: "Được đạo diễn năm 2011 bởi Michael Bay, Transformers: Dark of the Moon đã công phá các phòng vé vào năm 2011 và là một trong những bộ phim Transformers có doanh thu cao nhất mọi thời đại. Dark of the Moon tìm thấy Megatron, thủ lĩnh của Decepticons và là nhân vật phản diện chính của loạt phim Transformers; ba năm sau các sự kiện của Chiến dịch: Bão lửa lưu vong ở Châu Phi. Anh ta đang bị tổn hại nghiêm trọng trong trận chiến và đang âm mưu cho kế hoạch mới của mình."
            ,
            imageDescription: require('./productImage/Transformer/Megatron/megatron_transformers_feature.jpg'),
            company: "Prime 1 Studio",
            material: "Polystoney",
            tagName: ["Hành Động", "Robot"],
            size: "92.3 cm",
            otherImages:
                [
                    {
                        id: 520,
                        imgUrl: require('./productImage/Transformer/Megatron/megatron_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 521,
                        imgUrl: require('./productImage/Transformer/Megatron/megatron_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 522,
                        imgUrl: require('./productImage/Transformer/Megatron/megatron_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 523,
                        imgUrl: require('./productImage/Transformer/Megatron/megatron_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 105,
        name: "Megatron Deluxe Version",
        tagName: ["Hành Động", "Robot"],
        status: "preOrder",
        thumbImg: require('./productImage/Transformer/Megatron Deluxe Version/megatron-deluxe-version_transformers_silo_sm.png'),
        price: 725000,
        depositPrice: 250000,
        categoryID: 1,
        stock: 0,
        details:
        {
            description: "Hasbro và ThreeA tự hào giới thiệu Hình ảnh Sưu tập Quy mô Cao cấp Megatron (Phiên bản Deluxe) từ Transformers: The Last Knight! Megatron đã được điều chỉnh và thiết kế một cách tỉ mỉ thành một nhân vật sưu tầm có tính khớp nối cao bằng cách sử dụng mô hình phim làm cơ sở. Hình thang đo cao cấp Megatron (Phiên bản Deluxe) có các chi tiết được chiếu sáng bằng đèn LED, nhiều loại phụ kiện và lớp sơn phủ ngoài thời tiết cực kỳ chi tiết."
            ,
            imageDescription: require('./productImage/Transformer/Megatron Deluxe Version/megatron-deluxe-version_transformers_feature.jpg'),
            company: "ThreeA Toys",
            material: "ABS",
            tagName: ["Hành Động", "Robot"],
            size: "48.3 cm",
            otherImages:
                [
                    {
                        id: 524,
                        imgUrl: require('./productImage/Transformer/Megatron Deluxe Version/megatron-deluxe-version_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 525,
                        imgUrl: require('./productImage/Transformer/Megatron Deluxe Version/megatron-deluxe-version_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 526,
                        imgUrl: require('./productImage/Transformer/Megatron Deluxe Version/megatron-deluxe-version_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 527,
                        imgUrl: require('./productImage/Transformer/Megatron Deluxe Version/megatron-deluxe-version_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 106,
        name: "Optimus Prime",
        tagName: ["Hành Động", "Robot"],
        status: "available",
        thumbImg: require('./productImage/Transformer/Optimus Prime/optimus-prime_transformers_silo_sm (1).png'),
        price: 650000,
        categoryID: 1,
        stock: 10,
        details:
        {
            description: "Transformers: Revenge of the Fallen - DLX Optimus Prime được thiết kế để tích hợp với DLX Jetfire của cùng một bộ phim (dự kiến ​​phát hành vào quý 1 năm 2021). Cùng với nhau, hai nhân vật Transformers tạo thành DLX Jetpower Optimus Prime ấn tượng"
            ,
            imageDescription: require('./productImage/Transformer/Optimus Prime/optimus-prime_transformers_feature.jpg'),
            company: "ThreeA Toys",
            material: "ABS, POM, PVC, Diecast zinc alloy",
            tagName: ["Hành Động", "Robot"],
            size: "28.4 cm",
            otherImages:
                [
                    {
                        id: 528,
                        imgUrl: require('./productImage/Transformer/Optimus Prime/optimus-prime_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 529,
                        imgUrl: require('./productImage/Transformer/Optimus Prime/optimus-prime_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 530,
                        imgUrl: require('./productImage/Transformer/Optimus Prime/optimus-prime_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 531,
                        imgUrl: require('./productImage/Transformer/Optimus Prime/optimus-prime_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 106,
        name: "Optimus Prime DLX",
        tagName: ["Hành Động", "Robot"],
        status: "available",
        thumbImg: require('./productImage/Transformer/Optimus Prime DLX/optimus-prime-dlx_transformers_silo_sm.png'),
        price: 750000,
        categoryID: 1,
        stock: 10,
        details:
        {
            description: "Các phụ kiện bao gồm một Blaster Shield, một Balde đeo tay có thể tháo rời, một thanh kiếm Cybertronian, một mặt nạ chiến đấu có thể hoán đổi cho nhau, tổng cộng bốn cặp tay có thể hoán đổi cho nhau và một Chân đế hành động DLX cho nhiều tư thế biểu cảm khác nhau"
            ,
            imageDescription: require('./productImage/Transformer/Optimus Prime DLX/optimus-prime-dlx_transformers_feature.jpg'),
            company: "Threezero",
            material: "ABS, POM, PVC, Diecast zinc alloy",
            tagName: ["Hành Động", "Robot"],
            size: "28.4 cm",
            otherImages:
                [
                    {
                        id: 532,
                        imgUrl: require('./productImage/Transformer/Optimus Prime DLX/optimus-prime-dlx_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 533,
                        imgUrl: require('./productImage/Transformer/Optimus Prime DLX/optimus-prime-dlx_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 534,
                        imgUrl: require('./productImage/Transformer/Optimus Prime DLX/optimus-prime-dlx_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 535,
                        imgUrl: require('./productImage/Transformer/Optimus Prime DLX/optimus-prime-dlx_transformers_gallery_4.jpg'),
                    },
                    {
                        id: 536,
                        imgUrl: require('./productImage/Transformer/Optimus Prime DLX/optimus-prime-dlx_transformers_gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 107,
        name: "Optimus Prime Nendoroid",
        tagName: ["Hành Động", "Robot"],
        status: "available",
        thumbImg: require('./productImage/Transformer/Optimus Prime Nendoroid/optimus-prime-nendoroid_transformers_silo_sm.png'),
        price: 405000,
        categoryID: 1,
        stock: 10,
        details:
        {
            description: "Từ bộ phim mới nhất trong loạt phim Transformer, Optimus, là Nendoroid của thủ lĩnh Autobot, Optimus Prime! Nendoroid được hoàn thiện khớp nối, cho phép bạn tạo lại cảnh anh ta chỉ huy quân đội Autobot tại Cybertron."
            ,
            imageDescription: require('./productImage/Transformer/Optimus Prime Nendoroid/optimus-prime-nendoroid_transformers_feature.jpg'),
            company: "Sentinel",
            material: "ABS, PVC",
            tagName: ["Hành Động", "Robot"],
            size: "9.9 cm",
            otherImages:
                [
                    {
                        id: 537,
                        imgUrl: require('./productImage/Transformer/Optimus Prime Nendoroid/optimus-prime-nendoroid_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 538,
                        imgUrl: require('./productImage/Transformer/Optimus Prime Nendoroid/optimus-prime-nendoroid_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 539,
                        imgUrl: require('./productImage/Transformer/Optimus Prime Nendoroid/optimus-prime-nendoroid_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 540,
                        imgUrl: require('./productImage/Transformer/Optimus Prime Nendoroid/optimus-prime-nendoroid_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 108,
        name: "Optimus Prime",
        tagName: ["Hành Động", "Robot"],
        status: "preOrder",
        thumbImg: require('./productImage/Transformer/Optimus Prime v2/optimus-prime_transformers_silo_sm.png'),
        price: 750000,
        depositPrice: 250000,
        categoryID: 1,
        stock: 0,
        details:
        {
            description: "Optimus Prime được chế tác với sự chú ý ấn tượng đến các chi tiết và có đèn LED chiếu sáng trên các bộ phận khác nhau của bức tượng. Đầu có thể hoán đổi để lựa chọn đeo mặt nạ chiến đấu hoặc không đeo mặt nạ. Cánh tay phải có thể hoán đổi cho nhau để có thể lựa chọn giữa tư thế chỉ tay hoặc tư thế cầm nhiều loại vũ khí có thể hoán đổi."
            ,
            imageDescription: require('./productImage/Transformer/Optimus Prime v2/optimus-prime_transformers_feature.jpg'),
            company: "Prime 1 Studio",
            material: "Polystone",
            tagName: ["Hành Động", "Robot"],
            size: "73.3 cm",
            otherImages:
                [
                    {
                        id: 541,
                        imgUrl: require('./productImage/Transformer/Optimus Prime v2/optimus-prime_transformers_gallery_1.jpg'),
                    },
                    {
                        id: 542,
                        imgUrl: require('./productImage/Transformer/Optimus Prime v2/optimus-prime_transformers_gallery_2.jpg'),
                    },
                    {
                        id: 543,
                        imgUrl: require('./productImage/Transformer/Optimus Prime v2/optimus-prime_transformers_gallery_3.jpg'),
                    },
                    {
                        id: 544,
                        imgUrl: require('./productImage/Transformer/Optimus Prime v2/optimus-prime_transformers_gallery_4.jpg'),
                    },
                ],

        }
    },

    //DC Comics
    {
        id: 109,
        name: "Aquaman",
        tagName: ["Hành Động", "DC"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/DC Comics/Aquaman/aquaman_dc-comics_silo_sm.png'),
        price: 2560000,
        depositPrice: 750000,
        categoryID: 9,
        stock: 0,
        details:
        {
            description: "Sinh ra với cái tên Orin của người Atlantis, Arthur Curry là thái tử của Atlantis, còn được gọi là siêu anh hùng, Aquaman. Bức tượng chân dung này được điêu khắc cẩn thận dựa trên chân dung của Jason Momoa trong phim. Arthur Curry đang cầm trên tay phải di vật của người Atlantis cổ đại, còn được gọi là Cây đinh ba của Atlantis, được nắm giữ bởi vị vua Atlan cổ đại của Atlantis."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/Aquaman/aquaman_dc-comics_feature.jpg'),
            company: "Prime 1 Studio",
            material: "Polystone",
            tagName: ["Hành Động", "DC"],
            size: "88.9 cm",
            otherImages:
                [
                    {
                        id: 545,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Aquaman/aquaman_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 546,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Aquaman/aquaman_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 547,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Aquaman/aquaman_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 548,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Aquaman/aquaman_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 110,
        name: "Batman",
        tagName: ["Hành Động", "DC"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/DC Comics/Batman/batman_dc-comics_silo_sm.png'),
        price: 2460000,
        depositPrice: 750000,
        categoryID: 9,
        stock: 0,
        details:
        {
            description: "Hình nhân Batman Premium Format ™ sẵn sàng mang lại công lý cho thành phố của anh ấy, mặc một phiên bản cập nhật của bộ trang phục mang tính biểu tượng của anh ấy. Hình nhân vật polyresin có bộ bodysuit chiến thuật màu đen và xám được điêu khắc với một chiếc thắt lưng tiện ích bằng vàng. Ngực, găng tay và ủng của Người Dơi có kết cấu với các yếu tố sát thương trong trận chiến."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/Batman/batman_dc-comics_feature.jpg'),
            company: "Sideshow Collectibles",
            material: "Polyresin",
            tagName: ["Hành Động", "DC"],
            size: "59.7 cm",
            otherImages:
                [
                    {
                        id: 549,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman/batman_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 550,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman/batman_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 551,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman/batman_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 552,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman/batman_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 111,
        name: "Batman and Bat-Signal",
        tagName: ["Hành Động", "DC"],
        status: "new",
        thumbImg: require('./productImage/Marvel DC/DC Comics/Batman and Bat-Signal/batman-and-bat-signal_dc-comics_silo_sm.png'),
        price: 1760000,
        categoryID: 9,
        stock: 5,
        details:
        {
            description: "Caped Crusader đang trở lại màn bạc! Trong bộ phim Người dơi của DC, Robert Pattinson trở thành thám tử cảnh giác của Thành phố Gotham và bản ngã thay thế của anh ta, tỷ phú ẩn dật Bruce Wayne. Người anh hùng phải tạo dựng các mối quan hệ mới, vạch mặt thủ phạm và mang lại công lý cho việc lạm dụng quyền lực và tham nhũng đã gây ra từ lâu cho thành phố Gotham."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/Batman and Bat-Signal/batman-and-bat-signal_dc-comics_feature.jpg'),
            company: "Hot Toys",
            material: "PVC, ABS",
            tagName: ["Hành Động", "DC"],
            size: "31 cm",
            otherImages:
                [
                    {
                        id: 553,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman and Bat-Signal/batman-and-bat-signal_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 554,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman and Bat-Signal/batman-and-bat-signal_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 555,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman and Bat-Signal/batman-and-bat-signal_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 556,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman and Bat-Signal/batman-and-bat-signal_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 112,
        name: "Knightmare Batman",
        tagName: ["Hành Động", "DC"],
        status: "new",
        thumbImg: require('./productImage/Marvel DC/DC Comics/Batman Knightmare/batman-knightmare_dc-comics_silo_sm.png'),
        price: 956000,
        categoryID: 9,
        stock: 5,
        details:
        {
            description: "Knightmare Batman của DC Comics và Justice League của Zack Snyder! Dựa trên các tài liệu tham khảo ban đầu, bức tượng polystone này được vẽ bằng tay và là phiên bản giới hạn."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/Batman Knightmare/batman-knightmare_dc-comics_feature.jpg'),
            company: "Iron Studios",
            material: "Polystone",
            tagName: ["Hành Động", "DC"],
            size: "21.8 cm",
            otherImages:
                [
                    {
                        id: 557,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman Knightmare/batman-knightmare_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 558,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman Knightmare/batman-knightmare_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 559,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman Knightmare/batman-knightmare_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 560,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Batman Knightmare/batman-knightmare_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 113,
        name: "Catwoman",
        tagName: ["Hành Động", "DC"],
        status: "available",
        thumbImg: require('./productImage/Marvel DC/DC Comics/Catwoman/catwoman_dc-comics_silo_sm.png'),
        price: 877000,
        categoryID: 9,
        stock: 5,
        details:
        {
            description: "Tay cầm roi, nhân vật đeo mặt nạ đen bí ẩn, mặc đồng phục được may bằng những mảnh nhựa vinyl dính, thể hiện những móng vuốt kim loại ở các đầu ngón tay trái của mình một cách thách thức, được chống đỡ trên một chân đế lấy cảm hứng từ các tòa nhà lịch sử và lạnh lẽo của Gotham u ám City, với một con mèo đen ngồi trên bậc cầu thang bên cạnh cô ấy, giả làm linh vật và đồng minh của cô ấy. Cô ấy là Selina Kyle, hay còn được biết đến với cái tên Catwoman, do Michelle Pfeiffer thủ vai một cách thuần thục trong bộ phim kinh điển Batman Returns của đạo diễn Tim Burton."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/Catwoman/catwoman_dc-comics_feature.jpg'),
            company: "Iron Studios",
            material: "Polystone",
            tagName: ["Hành Động", "DC"],
            size: "19.8 cm",
            otherImages:
                [
                    {
                        id: 561,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Catwoman/catwoman_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 562,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Catwoman/catwoman_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 563,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Catwoman/catwoman_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 564,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Catwoman/catwoman_dc-comics_gallery_4.jpg'),
                    },
                    {
                        id: 565,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Catwoman/catwoman_dc-comics_gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 114,
        name: "Clark Kent Deluxe",
        tagName: ["Hành Động", "DC"],
        status: "available",
        thumbImg: require('./productImage/Marvel DC/DC Comics/Clark Kent Deluxe/clark-kent-deluxe_dc-comics_silo_sm.png'),
        price: 877000,
        categoryID: 9,
        stock: 6,
        details:
        {
            description: "Trên đỉnh một tòa nhà ở thành phố lớn Metrópolis, Clark Kent, phóng viên nhút nhát của tờ Daily Planet, nhìn thoáng qua bầu trời với vẻ mặt nghiêm túc và trầm ngâm, tập trung vào một mục tiêu ở xa, trong khi mở áo sơ mi để lộ màu đỏ và vàng không thể nhầm lẫn của mình. huy hiệu hình chữ S trên bộ đồ màu xanh lam rất phổ biến của anh ấy. Sẵn sàng cất cánh, với một số chú chim bồ câu, biểu tượng cao quý của hòa bình, và bên cạnh lá cờ của Hoa Kỳ, quốc gia nơi anh đã lớn lên và trở thành quê hương của anh, siêu nhân này được Iron Studios giới thiệu trong Clark Kent Deluxe hoành tráng Tượng - DC Comics - Art Scale 1:10 - Iron Studios , với hình ảnh anh hùng của các anh hùng trong phiên bản không kém phần quan trọng của anh ấy, của một dân thường"
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/Clark Kent Deluxe/clark-kent-deluxe_dc-comics_feature.jpg'),
            company: "Iron Studios",
            material: "Polystone",
            tagName: ["Hành Động", "DC"],
            size: "29 cm",
            otherImages:
                [
                    {
                        id: 566,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Clark Kent Deluxe/clark-kent-deluxe_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 567,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Clark Kent Deluxe/clark-kent-deluxe_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 568,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Clark Kent Deluxe/clark-kent-deluxe_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 569,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Clark Kent Deluxe/clark-kent-deluxe_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 115,
        name: "Green Lantern",
        tagName: ["Hành Động", "DC"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/DC Comics/Green Lantern/green-lantern_dc-comics_silo_sm.png'),
        price: 678500,
        depositPrice: 356000,
        categoryID: 9,
        stock: 0,
        details:
        {
            description: "Green Lantern là một nhân viên thực thi pháp luật liên ngân hà và là thành viên của Green Lantern Corps. Anh được chọn bởi những Người Bảo vệ Vũ trụ nhờ khả năng vượt qua những trở ngại lớn bằng cách sử dụng một chiếc nhẫn sức mạnh được điều khiển bởi suy nghĩ của anh. Với chiều cao ấn tượng 16 inch, thành viên sáng lập Liên minh Công lý này được vẽ bằng tay trên nền động."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/Green Lantern/green-lantern_dc-comics_feature.jpg'),
            company: "Tweeterhead",
            material: "PVC, Resin",
            tagName: ["Hành Động", "DC"],
            size: "40 cm",
            otherImages:
                [
                    {
                        id: 570,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Green Lantern/green-lantern_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 571,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Green Lantern/green-lantern_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 572,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Green Lantern/green-lantern_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 573,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Green Lantern/green-lantern_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 116,
        name: "Harley Quinn (Caution Tape Jacket Version)",
        tagName: ["Hành Động", "DC"],
        status: "available",
        thumbImg: require('./productImage/Marvel DC/DC Comics/Harley Quinn (Caution Tape Jacket Version/harley-quinn-caution-tape-jacket-version_dc-comics_silo_sm.png'),
        price: 858500,
        categoryID: 9,
        stock: 10,
        details:
        {
            description: "Hình ảnh sưu tập quy mô thứ sáu của Hot Toys 'Harley Quinn (Phiên bản áo khoác Caution Tape) không chỉ bao gồm trang phục mới nhất của Harley Quinn, Áo khoác Wings Caution Tape với các họa tiết tua rua đầy màu sắc, mà còn có một bộ trang phục biểu tượng tinh tế khác được thấy khi cô ấy xông vào đồn cảnh sát, cho phép người hâm mộ trổ tài với tủ quần áo độc đáo của Harley."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/Harley Quinn (Caution Tape Jacket Version/harley-quinn-caution-tape-jacket-version_dc-comics_feature.jpg'),
            company: "Hot Toys",
            material: "PVC, ABS",
            tagName: ["Hành Động", "DC"],
            size: "29 cm",
            otherImages:
                [
                    {
                        id: 574,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Harley Quinn (Caution Tape Jacket Version/harley-quinn-caution-tape-jacket-version_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 575,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Harley Quinn (Caution Tape Jacket Version/harley-quinn-caution-tape-jacket-version_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 576,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Harley Quinn (Caution Tape Jacket Version/harley-quinn-caution-tape-jacket-version_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 577,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/Harley Quinn (Caution Tape Jacket Version/harley-quinn-caution-tape-jacket-version_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 117,
        name: "The Flash",
        tagName: ["Hành Động", "DC"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/DC Comics/The Flash/the-flash_dc-comics_silo_sm.png'),
        price: 2750000,
        depositPrice: 350000,
        categoryID: 9,
        stock: 0,
        details:
        {
            description: "Hình Flash Premium Format ™ được kết xuất bằng polyresin và có một bộ đồ được điêu khắc hoàn toàn để ghi lại cơ bắp chi tiết của vóc dáng thể thao của Barry Allen. Bộ trang phục màu đỏ thẫm có đường ống điêu khắc và đường khâu được thiết kế để bắt chước vẻ ngoài của vải khi người đàn ông còn sống chạy nước rút nhanh nhất về phía kẻ thù tiếp theo của mình. Trang phục của Flash cũng có các điểm nhấn màu vàng với họa tiết tia chớp của anh ấy trên cánh tay, ngực, thắt lưng và ủng của bức tượng, cũng như đôi cánh màu vàng trên chiếc áo bò màu đỏ của Barry."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/The Flash/the-flash_dc-comics_feature.jpg'),
            company: "Sideshow Collectibles",
            material: "Polyresin",
            tagName: ["Hành Động", "DC"],
            size: "43.2 cm",
            otherImages:
                [
                    {
                        id: 578,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Flash/the-flash_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 579,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Flash/the-flash_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 580,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Flash/the-flash_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 581,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Flash/the-flash_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 118,
        name: "The Joker",
        tagName: ["Hành Động", "DC"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/DC Comics/The Joker/the-joker_dc-comics_silo_sm.png'),
        price: 5550000,
        depositPrice: 750000,
        categoryID: 9,
        stock: 0,
        details:
        {
            description: "Để kỷ niệm 80 năm The Joker: The Clown Prince of Crime, Blitzway và Prime 1 Studio tự hào công bố tác phẩm hợp tác thứ hai về siêu phẩm The Joker Tỉ lệ 1: 3 dựa trên bộ phim miêu tả sự ra đời của Joker, với sự tham gia của Joaquin. Phượng Hoàng. Trong khi chia sẻ mục tiêu chung là tạo ra Joker hay nhất mọi thời đại thông qua dự án này, chúng tôi đã có thể tạo ra kiệt tác tốt nhất thông qua hợp tác chặt chẽ và trao đổi phát triển trong toàn bộ quá trình sản xuất, từ thiết kế ý tưởng, sản xuất, quay phim và công bố dự định."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/The Joker/the-joker_dc-comics_feature.jpg'),
            company: "Prime 1 Studio",
            material: "Polystone",
            tagName: ["Hành Động", "DC"],
            size: "71 cm",
            otherImages:
                [
                    {
                        id: 582,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Joker/the-joker_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 583,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Joker/the-joker_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 584,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Joker/the-joker_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 585,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Joker/the-joker_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 119,
        name: "The Joker Deluxe",
        tagName: ["Hành Động", "DC"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/DC Comics/The Joker Deluxe/the-joker-deluxe_dc-comics_silo_sm.png'),
        price: 2450000,
        depositPrice: 650000,
        categoryID: 9,
        stock: 0,
        details:
        {
            description: "Trên đỉnh của một cột vật tổ bằng bê tông, được trang trí bằng các tác phẩm điêu khắc của những con trâu thời trung cổ xung quanh anh ta, đó là biểu tượng của thẻ chơi đã truyền cảm hứng cho tên của anh ta, nhân vật phản diện đáng sợ nhất của Gotham đặt ra trên cơ sở đó mặc bộ trang phục màu tím trang trọng và đưa một trong những bàn tay của anh ta. thẻ trình bày dưới dạng thẻ chơi nói tên của mình. Iron Studios tự hào mang đến một trong những nhân vật được người hâm mộ và những người sưu tập yêu cầu nhiều nhất về tên hề phản diện hỗn loạn, Tượng Joker - Hiệp sĩ bóng đêm - Tỷ lệ nghệ thuật 1:10 - Iron Studios, ở một trong những hình ảnh đại diện nổi bật và mang tính biểu tượng nhất của hãng."
            ,
            imageDescription: require('./productImage/Marvel DC/DC Comics/The Joker Deluxe/the-joker-deluxe_dc-comics_feature.jpg'),
            company: "Iron Studios",
            material: "Polystone",
            tagName: ["Hành Động", "DC"],
            size: "30 cm",
            otherImages:
                [
                    {
                        id: 586,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Joker Deluxe/the-joker-deluxe_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 587,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Joker Deluxe/the-joker-deluxe_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 588,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Joker Deluxe/the-joker-deluxe_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 589,
                        imgUrl: require('./productImage/Marvel DC/DC Comics/The Joker Deluxe/the-joker-deluxe_dc-comics_gallery_4.jpg'),
                    },
                ],

        }
    },

    //Marvel
    {
        id: 120,
        name: "Black Panther",
        tagName: ["Hành Động", "Marvel"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/Marvel/Black Panther/black-panther-premium-format-figure_marvel_silo_sm.png'),
        price: 6520000,
        depositPrice: 950000,
        categoryID: 8,
        stock: 0,
        details:
        {
            description: "Tượng tỷ lệ Black Panther 1: 4 bằng polystone được điêu khắc hoàn toàn để mang lại vẻ ngoài mang tính biểu tượng cho sự xuất hiện trên màn ảnh của nhân vật trong Vũ trụ Điện ảnh Marvel. Bộ đồ của T’Challa có cả ứng dụng sơn đen mờ và đen bóng cũng như các điểm nhấn màu bạc Vibranium để nhấn mạnh các họa tiết chi tiết. Thiết kế kiểu dáng đẹp của Wakandan làm nổi bật vóc dáng vạm vỡ của nhà vua và bức tượng Marvel này có hai bức chân dung riêng biệt - mặt nạ Black Panther đặc trưng của ông và một cái đầu không che mặt. Chọn cách Black Panther đáp ứng bộ sưu tập Marvel của bạn với các tùy chọn hiển thị thay thế này."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Black Panther/black-panther-premium-format-figure_marvel_feature.jpg'),
            company: "Sideshow Collectibles",
            material: "Polystone",
            tagName: ["Hành Động", "Marvel"],
            size: "67.3 cm",
            otherImages:
                [
                    {
                        id: 590,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Black Panther/black-panther_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 591,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Black Panther/black-panther_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 592,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Black Panther/black-panther_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 593,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Black Panther/black-panther_marvel_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 121,
        name: "Captain America",
        tagName: ["Hành Động", "Marvel"],
        status: "available",
        thumbImg: require('./productImage/Marvel DC/Marvel/Captain America/captain-america__silo_sm.png'),
        price: 756000,
        categoryID: 8,
        stock: 6,
        details:
        {
            description: "Nhân vật sưu tập Captain America có độ chính xác cao được chế tạo một cách chuyên nghiệp dựa trên sự xuất hiện của Chris Evans trong vai Captain America / Steve Rogers trong Avengers: Endgame. Nổi bật với tác phẩm điêu khắc đầu đội mũ bảo hiểm mới được sơn với ba khuôn mặt dưới có thể hoán đổi cho nhau ghi lại nét mặt của Chris Evan và tác phẩm điêu khắc đầu không đội mũ bảo hiểm, thân hình vạm vỡ khắc họa tự nhiên thân hình săn chắc vạm vỡ của Captain America, bộ trang phục được may đo tỉ mỉ với biểu tượng ngôi sao trên ngực, Cap's lá chắn có hình ngôi sao, la bàn tinh xảo, mũ bảo hiểm đặc trưng và giá đỡ nhân vật theo chủ đề phim được thiết kế đặc biệt."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Captain America/captain-america_marvel_feature.jpg'),
            company: "Hot Toys",
            material: "PVC, ABS",
            tagName: ["Hành Động", "Marvel"],
            size: "31 cm",
            otherImages:
                [
                    {
                        id: 594,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Captain America/captain-america_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 595,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Captain America/captain-america_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 596,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Captain America/captain-america_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 597,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Captain America/captain-america_marvel_gallery_4.jpg'),
                    },
                    {
                        id: 598,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Captain America/captain-america_marvel_gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 122,
        name: "Hulkbuster Deluxe Version",
        tagName: ["Hành Động", "Marvel"],
        status: "available",
        thumbImg: require('./productImage/Marvel DC/Marvel/Hulkbuster Deluxe Version/hulkbuster-deluxe-version_marvel_silo_sm.png'),
        price: 7850600,
        categoryID: 8,
        stock: 3,
        details:
        {
            description: "Được chế tác tinh xảo dựa trên sự xuất hiện của Hulkbuster trong Avengers: Age of Ultron, tượng khổng lồ chính xác trong phim cao khoảng 55 cm (21 inch) và bao gồm tượng bán thân Mark XLIII với đôi mắt phát sáng LED và lò phản ứng hồ quang trên ngực. có thể được đặt bên trong cỗ máy khổng lồ. Bộ giáp mang tính biểu tượng này được làm nổi bật với màu đỏ kim loại, sơn vàng và bạc và hiệu ứng thời tiết với hơn 20 vùng sáng LED nằm ở mắt, ngực, lòng bàn tay đẩy lùi, lưng và chân, một chiếc áo giáp ngực bị hư hại có thể hoán đổi cho nhau, cũng là chiếc rương được thiết kế đẹp mắt và áo khoác vai làm nổi bật các chi tiết cơ khí."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Hulkbuster Deluxe Version/hulkbuster-deluxe-version_marvel_feature.jpg'),
            company: "Hot Toys",
            material: "PVC, ABS",
            tagName: ["Hành Động", "Marvel"],
            size: "53.3 cm",
            otherImages:
                [
                    {
                        id: 599,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Hulkbuster Deluxe Version/hulkbuster-deluxe-version_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 560,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Hulkbuster Deluxe Version/hulkbuster-deluxe-version_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 561,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Hulkbuster Deluxe Version/hulkbuster-deluxe-version_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 562,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Hulkbuster Deluxe Version/hulkbuster-deluxe-version_marvel_gallery_4.jpg'),
                    },
                    {
                        id: 563,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Hulkbuster Deluxe Version/hulkbuster-deluxe-version_marvel_gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 123,
        name: "Iron Man Mark VII",
        tagName: ["Hành Động", "Marvel"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/Marvel/Iron Man Mark VII/iron-man-mark-vii_marvel_silo_sm.png'),
        price: 6520000,
        depositPrice: 750000,
        categoryID: 8,
        stock: 0,
        details:
        {
            description: "Iron Man Mark VII Maquette có lò phản ứng hồ quang sáng lên, mắt và bộ phản lực để biến Avenger bọc thép trở nên sống động trong bộ sưu tập của bạn. Đế nổ cũng sáng lên để chiếu sáng đám mây khói, ngọn lửa xả ra từ giày của Iron Man và tên lửa phóng từ cánh tay trái của anh ấy, tạo ra một cảnh ly kỳ trong bất kỳ màn hình nào của Marvel Cinematic Universe."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Iron Man Mark VII/iron-man-mark-vii_marvel_feature.jpg'),
            company: "Sideshow Collectibles",
            material: "Polystone , Resin",
            tagName: ["Hành Động", "Marvel"],
            size: "55.9 cm",
            otherImages:
                [
                    {
                        id: 564,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Man Mark VII/iron-man-mark-vii_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 565,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Man Mark VII/iron-man-mark-vii_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 566,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Man Mark VII/iron-man-mark-vii_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 567,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Man Mark VII/iron-man-mark-vii_marvel_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 124,
        name: "Iron Man Neon Tech 4.0",
        tagName: ["Hành Động", "Marvel"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/Marvel/Iron Man Neon Tech 4.0/iron-man-neon-tech-40__silo_sm.png'),
        price: 2560000,
        depositPrice: 650000,
        categoryID: 8,
        stock: 0,
        details:
        {
            description: "Đứng cao khoảng 32cm, hình tượng diecast hoàn toàn mới lấy cảm hứng từ sự xuất hiện của Iron Man Mark L trong Avengers: Infinity War có bộ giáp được sắp xếp hợp lý với các hoa văn bất đối xứng; được đánh bóng đẹp mắt với màu đen, xám và cam neon sáng bóng với các hoa văn phản chiếu phát sáng xuất hiện dưới ánh sáng LED chuyên dụng, cũng là một lựa chọn các bộ phận áo giáp tốt được làm bằng vật liệu mờ trong suốt nâng cao vẻ ngoài tổng thể; Chức năng bật sáng đèn LED rải rác khắp áo giáp; Các vũ khí đặc trưng của Iron Man bao gồm Pháo phản lực LED có thể hoán đổi cho nhau, Pháo tay, Bộ tăng tốc Nano, Lưỡi dao năng lượng, Khiên Holo và giá đỡ hình nhân được thiết kế đặc biệt."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Iron Man Neon Tech 4.0/iron-man-neon-tech-40__feature.jpg'),
            company: "Hot Toys",
            material: "PVC",
            tagName: ["Hành Động", "Marvel"],
            size: "32 cm",
            otherImages:
                [
                    {
                        id: 568,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Man Neon Tech 4.0/iron-man-neon-tech-40__gallery_1.jpg'),
                    },
                    {
                        id: 569,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Man Neon Tech 4.0/iron-man-neon-tech-40__gallery_2.jpg'),
                    },
                    {
                        id: 570,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Man Neon Tech 4.0/iron-man-neon-tech-40__gallery_3.jpg'),
                    },
                    {
                        id: 571,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Man Neon Tech 4.0/iron-man-neon-tech-40__gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 125,
        name: "Iron Patriot",
        tagName: ["Hành Động", "Marvel"],
        status: "new",
        thumbImg: require('./productImage/Marvel DC/Marvel/Iron Patriot/iron-patriot-sixth-scale-figure_marvel_silo_sm.png'),
        price: 3650450,
        categoryID: 8,
        stock: 7,
        details:
        {
            description: "Con số sưu tập diecast có độ chính xác cao này được chế tạo đặc biệt dựa trên sự xuất hiện của Don Cheadle trong vai James Rhodes / Iron Patriot trong Avengers: Endgame. Hình này có hai phần đầu có thể hoán đổi cho nhau, bao gồm phần đầu điêu khắc mới được phát triển với vẻ đẹp đáng chú ý cũng như phần đầu đội mũ có chức năng chiếu sáng bằng đèn LED. Iron Patriot có bộ giáp sơn màu xanh lam kim loại và màu cam đỏ với thiết kế áo giáp hợp lý, lò phản ứng Arc và pháo phản lực đẩy sáng bằng đèn LED ở ngực, vũ khí có khớp nối với đại bác gắn phía sau và bệ phóng tên lửa vác vai, và nhân vật theo chủ đề Avengers: Endgame được thiết kế đặc biệt căn cứ."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Iron Patriot/iron-patriot-sixth-scale-figure_marvel_feature.jpg'),
            company: "Hot Toys",
            material: "Diecast zinc alloy",
            tagName: ["Hành Động", "Marvel"],
            size: "32.5 cm",
            otherImages:
                [
                    {
                        id: 572,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Patriot/iron-patriot-sixth-scale-figure_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 573,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Patriot/iron-patriot-sixth-scale-figure_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 574,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Patriot/iron-patriot-sixth-scale-figure_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 575,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Iron Patriot/iron-patriot-sixth-scale-figure_marvel_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 126,
        name: "Moon Knight",
        tagName: ["Hành Động", "Marvel"],
        status: "new",
        thumbImg: require('./productImage/Marvel DC/Marvel/Moon Knight/moon-knight_marvel_silo_sm.png'),
        price: 3650450,
        categoryID: 8,
        stock: 15,
        details:
        {
            description: "Lấy cảm hứng từ sự xuất hiện mang tính biểu tượng của anh ấy trong series Moon Knight, hình tượng Moon Knight thứ sáu có hình điêu khắc đầu mới được phát triển với chức năng bật sáng bằng đèn LED; băng quấn được điêu khắc hoàn toàn để thể hiện vẻ ngoài thần bí của anh ta; một bộ trang phục Moon Knight được thiết kế tinh xảo bao gồm các bộ phận áo giáp cũng được bao phủ bởi các biểu tượng và hoa văn cổ, thắt lưng vải ngoài đôi ủng chạm trổ; những lưỡi liềm đặc trưng của anh ấy có nhiều kích cỡ khác nhau, phông nền hình trăng lưỡi liềm và chân đế hình người."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Moon Knight/moon-knight_marvel_feature.jpg'),
            company: "Hot Toys",
            material: "PVC, ABS",
            tagName: ["Hành Động", "Marvel"],
            size: "29 cm",
            otherImages:
                [
                    {
                        id: 576,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight/moon-knight_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 577,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight/moon-knight_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 578,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight/moon-knight_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 579,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight/moon-knight_marvel_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 127,
        name: "Moon Knight",
        tagName: ["Hành Động", "Marvel"],
        status: "new",
        thumbImg: require('./productImage/Marvel DC/Marvel/Moon Knight statue/moon-knight_dc-comics_silo_sm.png'),
        price: 4600450,
        categoryID: 8,
        stock: 15,
        details:
        {
            description: "Lấy cảm hứng từ sự xuất hiện mang tính biểu tượng của anh ấy trong series Moon Knight, hình tượng Moon Knight thứ sáu có hình điêu khắc đầu mới được phát triển với chức năng bật sáng bằng đèn LED; băng quấn được điêu khắc hoàn toàn để thể hiện vẻ ngoài thần bí của anh ta; một bộ trang phục Moon Knight được thiết kế tinh xảo bao gồm các bộ phận áo giáp cũng được bao phủ bởi các biểu tượng và hoa văn cổ, thắt lưng vải ngoài đôi ủng chạm trổ; những lưỡi liềm đặc trưng của anh ấy có nhiều kích cỡ khác nhau, phông nền hình trăng lưỡi liềm và chân đế hình người."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Moon Knight statue/moon-knight_dc-comics_feature.jpg'),
            company: "Iron Studios",
            material: "Polystone",
            tagName: ["Hành Động", "Marvel"],
            size: "30 cm",
            otherImages:
                [
                    {
                        id: 580,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight statue/moon-knight_dc-comics_gallery_1.jpg'),
                    },
                    {
                        id: 581,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight statue/moon-knight_dc-comics_gallery_2.jpg'),
                    },
                    {
                        id: 582,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight statue/moon-knight_dc-comics_gallery_3.jpg'),
                    },
                    {
                        id: 583,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight statue/moon-knight_dc-comics_gallery_4.jpg'),
                    },
                    {
                        id: 584,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Moon Knight statue/moon-knight_dc-comics_gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 128,
        name: "Nano Gauntlet",
        tagName: ["Hành Động", "Marvel"],
        status: "new",
        thumbImg: require('./productImage/Marvel DC/Marvel/Nano Gauntlet/nano-gauntlet_marvel_silo_sm.png'),
        price: 4600450,
        categoryID: 8,
        stock: 9,
        details:
        {
            description: "Bản sao Kích thước Thực của Găng tay Nano này là sự tái tạo trung thực của chiếc găng tay mang tính biểu tượng mà Người Sắt đã đeo trong màn cuối cùng của Avengers: Endgame. Với chiều cao tổng thể khoảng 52cm, nó có màu sơn chính xác với màu đỏ và vàng cổ điển của bộ giáp Iron Man, thiết kế phần cứng tinh vi, sáu Viên đá Vô cực phát sáng bằng đèn LED với hai chế độ chiếu sáng hoàn hảo để hiển thị, hoàn thiện với một đế tùy chỉnh giữ cho găng tay ở tư thế thẳng đứng."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Nano Gauntlet/nano-gauntlet_marvel_feature.jpg'),
            company: "Hot Toys",
            material: "PVC",
            tagName: ["Hành Động", "Marvel"],
            size: "52.1 cm",
            otherImages:
                [
                    {
                        id: 585,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Nano Gauntlet/nano-gauntlet_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 586,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Nano Gauntlet/nano-gauntlet_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 587,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Nano Gauntlet/nano-gauntlet_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 588,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Nano Gauntlet/nano-gauntlet_marvel_gallery_4.jpg'),
                    },
                    {
                        id: 589,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Nano Gauntlet/nano-gauntlet_marvel_gallery_5.jpg'),
                    },
                ],

        }
    },
    {
        id: 129,
        name: "Rescue",
        tagName: ["Hành Động", "Marvel"],
        status: "new",
        thumbImg: require('./productImage/Marvel DC/Marvel/Rescue/rescue_marvel_silo_sm.png'),
        price: 3600450,
        categoryID: 8,
        stock: 9,
        details:
        {
            description: "Được thiết kế đẹp mắt với các chi tiết tuyệt đẹp, nhân vật có độ chính xác cao được chế tác dựa trên sự xuất hiện trên màn ảnh rộng của Gwyneth Paltrow trong vai Pepper Potts / Giải cứu từ bộ phim MCU. Nổi bật với hai tác phẩm điêu khắc trên đầu có thể hoán đổi cho nhau bao gồm một tác phẩm điêu khắc trên đầu được sơn mới với mặt nạ có thể tháo rời và một đầu có mũ bảo hiểm có thể hoán đổi cho nhau với chức năng bật sáng đèn LED. Bộ sưu tập quy mô thứ sáu này có tính năng áp dụng khéo léo màu xanh hoa oải hương bằng kim loại, vàng sâm panh và áo giáp màu bạc. Đèn LED chiếu sáng qua các khu vực khác nhau của áo giáp, vũ khí mang tính biểu tượng bao gồm một máy bay không người lái dài và một máy bay không người lái ngắn để tái hiện cảnh chiến đấu cùng với Iron Man và The Avengers, nhiều cặp tay có thể hoán đổi cho nhau cho các cử chỉ khác nhau và một giá đỡ nhân vật năng động theo chủ đề."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Rescue/rescue_marvel_feature.jpg'),
            company: "Hot Toys",
            material: "PVC",
            tagName: ["Hành Động", "Marvel"],
            size: "31 cm",
            otherImages:
                [
                    {
                        id: 590,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Rescue/rescue_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 591,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Rescue/rescue_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 592,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Rescue/rescue_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 593,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Rescue/rescue_marvel_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 130,
        name: "Spider-Man (Deluxe Version) Special Edition",
        tagName: ["Hành Động", "Marvel"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/Marvel/Spider-Man (Deluxe Version) Special Edition/spider-man-deluxe-version-special-edition_marvel_silo_sm.png'),
        price: 7560000,
        depositPrice: 1500000,
        categoryID: 8,
        stock: 0,
        details:
        {
            description: "Hình ảnh sưu tập Người Nhện theo tỷ lệ một phần tư chính xác trên màn hình được chế tác dựa trên bộ đồ chiến đấu do Người Sắt tặng cho Peter Parker và có tác phẩm điêu khắc đầu đeo mặt nạ mới được phát triển với năm cặp thị kính hoán đổi cho nhau để tạo ra nhiều sự kết hợp biểu cảm của Người Nhện. Tác phẩm điêu khắc đầu có thể hoán đổi mới được phát triển có một nét giống Tom Holland đáng chú ý. Con số này tự hào có một cơ thể chuyên dụng mới được phát triển cao khoảng 43,5cm, một bộ trang phục được thiết kế riêng và rất chi tiết, một cặp cánh web có thể gắn từ tính, một loạt các phụ kiện bao gồm một Spider Drone, một bản đồ chiếu, một điện thoại thông minh, một ba lô , mặt nạ Người Nhện, một loạt các bộ phận hiệu ứng bắn mạng nhện và đế hình đèn LED chiếu sáng diorama với hai chế độ chiếu sáng để hiển thị thay thế lấy cảm hứng từ cảnh chiến đấu cuối cùng giữa Người Nhện và Kền kền."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Spider-Man (Deluxe Version) Special Edition/spider-man-deluxe-version-special-edition_marvel_feature.jpg'),
            company: "Hot Toys",
            material: "PVC",
            tagName: ["Hành Động", "Marvel"],
            size: "43.5 cm",
            otherImages:
                [
                    {
                        id: 594,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Spider-Man (Deluxe Version) Special Edition/spider-man-deluxe-version-special-edition_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 595,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Spider-Man (Deluxe Version) Special Edition/spider-man-deluxe-version-special-edition_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 596,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Spider-Man (Deluxe Version) Special Edition/spider-man-deluxe-version-special-edition_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 597,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Spider-Man (Deluxe Version) Special Edition/spider-man-deluxe-version-special-edition_marvel_gallery_4.jpg'),
                    },
                ],

        }
    },
    {
        id: 131,
        name: "Spider-Man (Spider-Man 2099 Black Suit)",
        tagName: ["Hành Động", "Marvel"],
        status: "preOrder",
        thumbImg: require('./productImage/Marvel DC/Marvel/Spider-Man (Spider-Man 2099 Black Suit)/spider-man-spider-man-2099-black-suit_marvel_silo_sm.png'),
        price: 7560000,
        depositPrice: 1500000,
        categoryID: 8,
        stock: 0,
        details:
        {
            description: "Hình ảnh sưu tập Người Nhện theo tỷ lệ một phần tư chính xác trên màn hình được chế tác dựa trên bộ đồ chiến đấu do Người Sắt tặng cho Peter Parker và có tác phẩm điêu khắc đầu đeo mặt nạ mới được phát triển với năm cặp thị kính hoán đổi cho nhau để tạo ra nhiều sự kết hợp biểu cảm của Người Nhện. Tác phẩm điêu khắc đầu có thể hoán đổi mới được phát triển có một nét giống Tom Holland đáng chú ý. Con số này tự hào có một cơ thể chuyên dụng mới được phát triển cao khoảng 43,5cm, một bộ trang phục được thiết kế riêng và rất chi tiết, một cặp cánh web có thể gắn từ tính, một loạt các phụ kiện bao gồm một Spider Drone, một bản đồ chiếu, một điện thoại thông minh, một ba lô , mặt nạ Người Nhện, một loạt các bộ phận hiệu ứng bắn mạng nhện và đế hình đèn LED chiếu sáng diorama với hai chế độ chiếu sáng để hiển thị thay thế lấy cảm hứng từ cảnh chiến đấu cuối cùng giữa Người Nhện và Kền kền."
            ,
            imageDescription: require('./productImage/Marvel DC/Marvel/Spider-Man (Spider-Man 2099 Black Suit)/spider-man-spider-man-2099-black-suit_marvel_feature.jpg'),
            company: "Hot Toys",
            material: "PVC",
            tagName: ["Hành Động", "Marvel"],
            size: "43.5 cm",
            otherImages:
                [
                    {
                        id: 598,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Spider-Man (Spider-Man 2099 Black Suit)/spider-man-spider-man-2099-black-suit_marvel_gallery_1.jpg'),
                    },
                    {
                        id: 599,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Spider-Man (Spider-Man 2099 Black Suit)/spider-man-spider-man-2099-black-suit_marvel_gallery_2.jpg'),
                    },
                    {
                        id: 600,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Spider-Man (Spider-Man 2099 Black Suit)/spider-man-spider-man-2099-black-suit_marvel_gallery_3.jpg'),
                    },
                    {
                        id: 601,
                        imgUrl: require('./productImage/Marvel DC/Marvel/Spider-Man (Spider-Man 2099 Black Suit)/spider-man-spider-man-2099-black-suit_marvel_gallery_4.jpg'),
                    },
                ],

        }
    },



]